import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
import { Component, NgModule, OnInit, OnDestroy } from '@angular/core';
import { DispatcherService } from './dispatcher.service';
import {
  FormGroup,
  AbstractControl,
  FormBuilder,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { MissionService } from '../app.constant';
import { MqttServiceService } from '../mqtt-service.service';
import { Subject } from 'rxjs';
import * as myGlobals from '../globals';
import { ConfigService } from '../config.service';
import { mapStyle } from '../utils/mapStyles';
import { CommunicationService } from './communication.service';

import { TranslateService } from '@ngx-translate/core';

declare const jQuery: any;
declare var google: any;
declare var $: any;
declare var value: any;
declare var flatpickr: any;
declare var PUBNUB: any;
declare var screenfull: any;
declare var AutocompleteDirectionsHandler: any;
declare var Stripe: any;
declare var moment: any;
declare var swal: any;
declare var unescape: any;
declare var toastr: any;
@Component({
  selector: 'dispatcher',
  animations: [
    trigger('myAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('400ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './dispatcher.component.html',
  styleUrls: [
    './dispatcherhome/dispatcherhome.component.css',
    './dispatcher.component.css'
  ]
})
export class DispatcherComponent implements OnInit, OnDestroy {
  [x: string]: any;
  apres: any;
  fp_incr: any;
  pickuplat;
  pickuplong;
  droplat;
  droplong;
  codAmount: any;
  photo = [];
  vechiletypes: any;
  approx = '...';
  approx_dist: any;
  vehicle_device_id: any;
  info;
  Path;
  zpath: any;
  getdata;
  own_later_date;
  own_drop_date: any;
  rec_name: any;
  rec_number: any;
  rec_mail: any;
  company_name: any;

  product_det: any;
  product_qty: any;
  product_wgt: any;
  vechicle_type: any;
  passDetailsContent: any;
  dynamic_latlong: any;
  file = [];
  data: any;
  fname_b: any;
  map: any;
  marker: any;
  style: any;
  fmail_b: any;
  pubnub: any;
  email: any;
  myphone: any;
  mymail: any;
  myname: any;
  first_name: any;
  phone: any;
  public form: FormGroup;
  public phoneNumber: AbstractControl;
  public password: AbstractControl;
  public submitted = false;
  current_time: any;
  current_time_var: any;
  zone_one_title: any;
  zone_amount: any;
  zone_two_title: any;
  journey_time: any;
  increment_num = 0;
  notify_bid: any;
  notify_sid: any = 0;
  approx_amount: any;
  booking_time: any;
  appt_type: number;
  zone_id_pick: any;
  zone_id_drop: any;
  notifications = [];
  result: any;
  change_pos: any;

  // current lat long varbles
  current_lat: any;
  current_lng: any;

  // pubnub variables
  pubnub_keys_pk: any;
  pubnub_keys_sk: any;

  // vehicle types;
  vehicle_types = [];
  vehicle_bool = true;
  // map varaibles
  mappickup_drop_bounds: any;
  pickup_marker_loc: any;
  drop_marker_loc: any;
  // livebooking variables
  vehicle_id: any;
  zone_one_id: any;
  zone_two_id: any;
  time_fare: any;
  dist_fare: any;
  dist: any;
  tme: any;

  show_add_card = false;
  goods_type_list = [];
  approx_dist_txt: any;
  category_id: any;
  category_name: any;
  show_error_bool = false;
  // new user validation
  signup_mail: any;
  signup_number: any;
  mail_bool = false;
  phone_bool = false;
  pickup_bool = true;
  pickup_loc_bool = false;
  drop_loc_bool = false;
  drop_bool = true;
  signup_otpcode: any;
  timer_i: any;
  counter_bool = false;
  drivers_vehicletype = [];
  drivers_vehicletype_markers = [];
  applied_amt;
  card_number = '';
  checking_vehs = false;
  pickup_ok = false;
  vehicles_empty = false;
  change_quantity = false;
  vehicles_interval: any;
  show_cards_hide = false;
  authorize_call: any;
  directionsDisplay: any;
  estimate_id: any;
  last_card_number: any;
  loose_qty = '0';
  pending_review = [];
  rating_b_details: any;
  driver_rating = [];
  rating_text = [];
  show_select = false;
  show_high_rating = false;
  show_low_rating = false;
  rating_num: any;
  rating_error = false;
  comment_error = false;
  show_highrate_comment = false;
  /*stripe payments */
  stripe_cardid: any;
  stripe_lastCard: any;
  stripe_cardType: any;
  currency: any;
  show_ratecard = false;
  validate_form: any;
  high_rating: any;
  capacity: any;
  length_var: any;
  fare: any;
  dis_fare: any;
  time_fare_est: any;
  x_mileage: any;
  x_min: any;
  handlers = 0;
  vehicle_type_load = false;
  metric_qty: any;
  /* PAYMENT DETAILS VARIABLES*/
  payment_type = 2;
  paidBy = 1;
  config_channel: any;
  showing_balance: any;
  credit_error_msg: any;
  credit_no_book = false;
  credit_line_interval: any;
  soft_limit_error = false;
  hard_limit_error = false;
  show_booklater = false;
  window = window;
  // AWSService: any = this.window.AWS;

  // new booking variables
  pickupdate: any;
  dropdate: any;
  vehicletypeid: any;
  vehiclename: any;
  goodsttype: any;
  senderName: any;
  senderNumber: number;
  goodstypeId: any;
  goodstypeName: any;
  loadtype = 'FTL';
  pickupaddress: any;
  dropaddress: any;
  distance: any;
  distance_text: any;
  duration: any;
  duration_txt: any;
  metric_ton = 'Kg';
  pickup_city_name: any;
  drop_city_name: any;
  job_loader = false;
  agent_id: any;
  fileToUpload: File = null;
  timefee: any;
  distancefee: any;
  pickup_loader = false;
  imageapiUrl = `${myGlobals.apiurl}utility/uploadImage`;
  fareEstimateDetails: any;
  enableBidding = false;
  weightMetrics = [];
  dimensionUnit = 'ft';
  product_lgt = '';
  product_wid = '';
  product_ht = '';
  initialCountryCode: any;
  initialCountryFlag: any;
  senderCountrycode: any;
  walletEnable: any;
  accountType = 0;
  isCardEnable = false;
  isCashEnable = false;
  isWalletEnable = false;
  show_cards = false;
  allcards = [];
  addcard: any;
  defaultcard: any;
  disphome: any;
  card_number_all: any;
  visa = false;
  amex = false;
  discover = false;
  jcb = false;
  diners = false;
  master = false;
  card_cvc: any;
  card_month: any;
  card_year: any;
  walletPay = 0;
  showAllPayments = false;
  currentVehicleCapacity;
  perHandlersPrice: number;
  finalHandlersPrice: any = 0;
  isPaidByReceiverEnable;
  isBookNowEnabled = false;
  isBookLaterEnabled = false;
  isReceiverConfirmationEnabled = true;
  isSecurityOtpIsEnabled = true;
  isBiddingEnabled: any;
  tripTimeInSeconds;
  IsPriceFixed = false;
  currentVehicleCapacityInUnits;
  customerEnteredPhone: Subject<string> = new Subject<string>();
  customerEnteredEmail: Subject<string> = new Subject<string>();
  customerEnteredName: Subject<string> = new Subject<string>();
  own_lat: any;
  currencyAbbr = 1;
  temp_finalAmount: any;
  allLanguages = [];
  defaultLanguage = 'en';
  enableDimensions = myGlobals.enableDimensions;
  handlersArr = [];

  constructor(
    private _dispatcherService: DispatcherService,
    fb: FormBuilder,
    public _router: Router,
    private _missionService: MqttServiceService,
    private _cookie: ConfigService,
    private _communicate: CommunicationService,
    private translate: TranslateService
  ) {
    this._missionService.mqttConnection();
    this.getLanguages();
    this.appconfig();
    this.form = fb.group({
      phoneNumber: ['', Validators.compose([Validators.required])],
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(4)])
      ]
    });
    this.phoneNumber = this.form.controls['phoneNumber'];
    this.password = this.form.controls['password'];
    // mqtt response
    _missionService.missionAnnounced$.subscribe((data: any) => {
      console.log('Dispatcher MQTT', JSON.parse(data));
      if (!data.status) {
        data = JSON.parse(data);
      }

      if (data.negotiation != undefined) {
        data.status = data.negotiation.status
          ? data.negotiation.status
          : data.status;
      } else {
        data.status = data.status;
      }

      const status = data.status;
      // if (data.bookingId) {
      // if (status >= 1) {
      //   $(`#notication_icon`)
      //     .addClass('animated swing')
      //     .one('animationend', function () {
      //       $(this).removeClass('animated swing');
      //     });
      //   this.increment_num++;
      //   const counterNumber = this.increment_num;
      //   $('#notification_bar').text(counterNumber);
      //   setTimeout(function () {
      //     $('#notification_bar').show();
      //   }, 200);
      //   const inputValue = (<HTMLMediaElement>(
      //     document.getElementById('audio')
      //   )).play();
      //   $('#notification_bar').addClass('active');
      //   $('#notification_ripple').addClass('active');
      //   window.setTimeout(() => {
      //     $('#notification_ripple').removeClass('active');
      //     $('#notification_bar').removeClass('active');
      //   }, 5000);
      // }
      $('.loader_cardadd_parent').hide();
      // console.log('', data);

      let index;
      switch (status) {
        case 1:
          data.statusTxt = ' New Load posted ';
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong> ' +
            data.statusTxt +
            ' </h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusTxt));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusTxt), this.increment_num++) : '';
          break;
        case 101:
          this.increment_num++;
          toastr['success']('<h5>' + data.negotiation.statusTxt + '</h5>');
          this.notifications.unshift(data.negotiation.statusTxt);
          break;
        case 102:
          this.increment_num++;
          toastr['success']('<h5>' + data.negotiation.statusTxt + '</h5>');
          this.notifications.unshift(data.negotiation.statusTxt);
          break;
        case 103:
          this.increment_num++;
          toastr['success']('<h5>' + data.negotiation.statusTxt + '</h5>');
          this.notifications.unshift(data.negotiation.statusTxt);
          break;
        case 104:
          this.increment_num++;
          toastr['success'](`${data.negotiation.statusTxt}`);
          this.notifications.unshift(
            `${data.negotiation.statusTxt}`
          );
          //${data.bookingId
          break;
        case 2:
          this.increment_num++;
          toastr['success']('<h5>' + data.bookingId + ' Booking accepted</h5>');
          this.notifications.unshift(data.bookingId + 'Booking accepted');
          break;
        case 3:
          // console.log('datassssss-------->', data);
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bid +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bid + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 4:
          // console.log('status 4----------->', data);
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bid +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.statusText), this.increment_num++) : '';
          break;
        case 5: // dispatcher counters
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bid +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.statusText), this.increment_num++) : '';
          break;
        case 6: // driver on the way
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 7: // driver arrived
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 8: this.increment_num++  // driver loaded
          break;
        case 9: // trip started
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 10: // reached to drop location
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 11: //unloaded
          toastr['success'](
            '<h5><strong>Load Id :</strong> ' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 12: // completed
          toastr['success'](
            '<h5><strong>Load Id :</strong>' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 13: // expired
          toastr['success'](
            '<h5><strong>Load Id :</strong>' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.statusText +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 14: // booking bid timer expired
          toastr['success'](
            '<h5><strong>Load Id :</strong>' +
            data.bookingId +
            '<br><br>' +
            '<strong>status :</strong>' +
            data.msg +
            '</h5>'
          );
          index = this.notifications.findIndex((x) => x == (data.bookingId + ' ' + data.statusText));
          // console.log('index', index)
          index <= -1 ? (this.notifications.unshift(data.bookingId + ' ' + data.statusText), this.increment_num++) : '';
          break;
        case 22:
          this.increment_num++
          console.log(`Booking Requested to the Driver(${data.email})`);
          toastr['success'](`Booking Requested to the Driver(${data.email})`);
          this.notifications.unshift(
            `Booking Requested to the Driver(${data.email})`
          );
          break;
        case 21:
          this.increment_num++;
          toastr['success'](`${data.statusText} ${data.bookingId}`);
          this.notifications.unshift(`${data.statusText} ${data.bookingId}`);
          break;
        case 15:
          this.increment_num++;
          toastr['success'](`${data.statusText} ${data.bookingId}`);
          this.notifications.unshift(`${data.statusText} ${data.bookingId}`);
          break;
        case 16: this.increment_num++; // driver unloaded
          break;
        case 10: this.increment_num++;
          break;
        case 17:
          this.increment_num++;
          swal({
            title: 'Are you sure?',
            text:
              'Google key Limit is Exceeded Please Conform to Reload the Page or Reload the Page Manually',
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then(willDelete => {
            if (willDelete) {
              window.location.reload();
            } else {
              swal('Please Reload the Page to Work flawlessly');
            }
          });
          break;
      }
      if (status >= 1) {
        $(`#notication_icon`)
          .addClass('animated swing')
          .one('animationend', function () {
            $(this).removeClass('animated swing');
          });
        // index <= -1 || index ? this.increment_num++ : '';
        const counterNumber = this.increment_num;
        $('#notification_bar').text(counterNumber);
        setTimeout(function () {
          $('#notification_bar').show();
        }, 200);
        const inputValue = (<HTMLMediaElement>(
          document.getElementById('audio')
        )).play();
        $('#notification_bar').addClass('active');
        $('#notification_ripple').addClass('active');
        window.setTimeout(() => {
          $('#notification_ripple').removeClass('active');
          $('#notification_bar').removeClass('active');
        }, 5000);
      }
      // }
      // console.log('notificatiions--------->', this.notifications);
    });
  }

  public onSubmitLogin(values: Object): void {
    this.submitted = true;

    if (this.form.valid) {
      // your code goes here
    }
  }

  handleStatus(statuscode, error?) {
    console.log('handleStatus', statuscode, error);
    $('.modal').modal('hide');
    $('.loader_cardadd_parent').hide();
    if (statuscode >= 500) {
      statuscode = 500;
    }
    switch (statuscode) {
      case 401:
        this._cookie.removeItem();
        this._router.navigate(['login']);
        // toastr['warning']('You have been logged out. Please login to continue');
        break;
      case 500:
        toastr['warning']('Could not connect to server');
        break;
      default:
        toastr['warning'](`${error.message}`);
    }
  }

  loggout() {
    this._dispatcherService
      .loggedout({
        // userType: 1,
      })
      .subscribe(
        (res: any) => {
          clearInterval(this.authorize_call);
          this._cookie.removeItem();
          this._cookie.clearAllCookies();
          this._router.navigate(['login']);
        },
        err => {
          $('.loader_cardadd_parent').hide();
          this.handleStatus(err.status, err.error);
        }
      );
  }

  notification() {
    $('#notification_body').toggle();
    $('#notification_bar').hide();
    $('#notification_bar').text(0);
    this.increment_num = 0;
  }

  myFunction() {
    const x = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }
  onImageRemoved(e) {
    console.log(e);
    const response = e.serverResponse.response.body;
    const index = this.file.indexOf(response.data.url);
    if (index !== -1) {
      this.file.splice(index, 1);
    }
  }

  onUploadFinished(e) {
    console.log('Image Upload---->', e);
    // const response = JSON.parse(e.serverResponse.response.body);
    const response = e.serverResponse.response.body;
    this.file.push(response.data.url);
    // const response = e.serverResponse._body;
    // this.file.push(response.data.url);
  }
  change_fav_icn() {
    if ($('.mute_on').hasClass('fa-volume-up')) {
      $('.mute_on').removeClass('fa-volume-up');
      $('.mute_on').addClass('fa-volume-off');
      const aud_tag: any = document.getElementById('audio');
      aud_tag.src = '';
    } else {
      $('.mute_on').addClass('fa-volume-up');
      $('.mute_on').removeClass('fa-volume-off');
      const aud: any = document.getElementById('audio');
      aud.src = 'https://www.soundjay.com/transportation/sounds/car-honk-1.mp3';
    }
  }

  date_success() {
    $('.date_success_change').addClass('has-success');
  }

  delete_photo(id) {
    // delete imaage from array
    $('.ref_img' + id).remove();
    this.file.splice(id - 1, 1);
  }

  imgsrc(fileInput: any, id) {
    // triggers appro input file
    $('#input_upload' + id).trigger('click');
  }

  uploadImg_api(input) {
    this._dispatcherService
      .uploadImages({
        input
      })
      .subscribe(
        (res: any) => { },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  // Uploads img to   appro input file
  uploadImg(fileInput, id) {
    this.fileToUpload = fileInput.item(0);
    // this.uploadImg_api(this.fileToUpload);
    this._dispatcherService
      .uploadImages({
        image: this.fileToUpload
      })
      .subscribe(
        (res: any) => { },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
    // const fileBrowser = fileInput.srcElement;
    // console.log(fileBrowser.files[0]);
    // if (fileBrowser.files && fileBrowser.files[0]) {
    //   const formData = new FormData();
    //   formData.append("image---->", fileBrowser.files[0]);
    //   this.uploadImg_api(fileBrowser.files[0]);
    // }
    // const input = fileInput.srcElement;
    // console.log("checkingfile---------->", fileInput.srcElement.id);
    // if (input.files && input.files[0]) {
    //   const formData = new FormData();
    //   formData.append("image", input.files[0]);
    //   this.uploadImg_api(formData);
    //   var reader = new FileReader();
    //   reader.onload = function (e: any) {
    //     $('#upload' + id).attr("src", e.target.result);
    //     $(".delete_photo" + id).show();
    //     $(".show_upload" + id).show();
    //   }
    // }
    // reader.readAsDataURL(input.files[0]);
    // console.log("files", fileInput.target.files[0]);
    // //this.resizeAndUpload(fileInput.target.files[0],id);
    // var compose = fileInput.target.files[0];

    // const resizeImage = (settings: { maxSize, file }) => {           // resizesing image function
    //   const file = settings.file;
    //   const maxSize = settings.maxSize;
    //   const reader = new FileReader();
    //   const image = new Image();
    //   const canvas = document.createElement('canvas');
    //   const dataURItoBlob = (dataURI: string) => {
    //     const bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
    //       atob(dataURI.split(',')[1]) :
    //       unescape(dataURI.split(',')[1]);
    //     const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
    //     const max = bytes.length;
    //     const ia = new Uint8Array(max);
    //     for (let i = 0; i < max; i++) {ia[i] = bytes.charCodeAt(i); }
    //     return new Blob([ia], { type: mime });
    //   };
    //   const resize = () => {
    //     let width = image.width;
    //     let height = image.height;

    //     if (width > height) {
    //       if (width > maxSize) {
    //         height *= maxSize / width;
    //         width = maxSize;
    //       }
    //     } else {
    //       if (height > maxSize) {
    //         width *= maxSize / height;
    //         height = maxSize;
    //       }
    //     }

    //     canvas.width = width;
    //     canvas.height = height;
    //     canvas.getContext('2d').drawImage(image, 0, 0, width, height);
    //     const dataUrl = canvas.toDataURL('image/png');
    //     return dataURItoBlob(dataUrl);
    //   };

    //   return new Promise((ok, no) => {
    //     if (!file.type.match(/image.*/)) {
    //       no(new Error("Not an image"));
    //       return;
    //     }

    //     reader.onload = (readerEvent: any) => {
    //       image.onload = () => ok(resize());
    //       image.src = readerEvent.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   })
    // };

    // resizeImage({                                            // resize image call
    //   file: compose,
    //   maxSize: 200
    // }).then((resizedImage: any) => {
    //   console.log("upload resized image")
    //   console.log(resizedImage);

    //   const files = fileInput.target.files[0];
    //   console.log("fileInput", fileInput.target.files[0]);
    //   function getRandomInt(min, max) {
    //     return "webcustomer" + Math.floor(Math.random() * (max - min + 1)) + min;      // pushiing to this.file array
    //   }
    //   var img = new File([resizedImage], getRandomInt(1, 10000));
    //   this.file.push(img);
    //   // const formData = new FormData();
    //   // formData.append('file', img);
    //   // this.uploadImg_api(img);
    //     // const formData = new FormData();
    //     // formData.append("image", resizedImage);
    //     // this.uploadImg_api(formData);
    //   console.log(img);
    // }).catch(function (err) {
    //   console.error(err);
    // });
  }

  // DRAWING ROUTES BASED ON PICKUP AND DROPLATLONGS

  // getVechicles() {
  //   this.vehicle_types = [];
  //   this.vehicles_api();
  // }

  // vehicles_api() {
  //   if (this.vehicle_types.length == 0) {
  //     this.vehicle_type_load = true;
  //   }
  //   this._dispatcherService.vehicles({
  //   }).subscribe((res: any) => {
  //       console.log('vehicletypes',res);
  //       if (this.vehicle_types.length == 0) {
  //         for (let inst = 0; inst < res.data.length; inst++) {
  //           this.vehicle_types.push(res.data[inst]);
  //         }
  //       }
  //       this.vehicle_type_load = false;
  //   },
  //   err => {
  //     err = JSON.parse(err.error)
  //     if (err.status == 400) {
  //       alert(err.message);
  //     }else {
  //       toastr['warning']('Could not connect to server')
  //     }
  //   });
  // }

  // if same as sender is ticked then copy samething in receiver
  copyText(event, val) {
    if ($('#sender_input').is(':checked')) {
      if (val == 0) {
        this.rec_name = this.senderName;
      } else {
        this.rec_number = this.senderNumber;
      }
      setTimeout(() => {
        this.validate_form.element('#receivername');
        this.validate_form.element('#receivernumber');
      }, 100);
    }
  }

  checkText(event, val) {
    if ($('#sender_input').is(':checked')) {
      if (this.rec_name !== this.senderName) {
        $('#sender_input').attr('checked', false);
      } else if (this.rec_number !== this.senderNumber) {
        $('#sender_input').attr('checked', false);
      }
      setTimeout(() => {
        this.validate_form.element('#receivername');
        this.validate_form.element('#receivernumber');
      }, 100);
    }
  }

  // same as customer
  sameAsCustomer(check = true) {
    event.preventDefault();
    if ($('#sameAsCustomer').is(':checked')) {
      if (this.cust_phone && this.cust_name && this.cust_mail) {
        // console.log('Same As Cus---><<', this.cust_phone, this.cust_name, this.cust_mail);
        this.senderName = this.cust_name;
        // this.senderNumber = this.cust_phone;
        $('#sendername').val(this.cust_name);
        this.senderNumber = this.cust_phone;
        setTimeout(() => {
          $('#sendernumber').intlTelInput('setNumber', this.cust_phone);
        }, 100);
        $('#sendername').attr('disabled', true);
        $('#sendernumber').attr('disabled', true);
        this.validate_form.element('#sendername,#sendernumber');
        if ($('#sender_input').is(':checked')) {
          this.sameasSender();
        }
      } else {
        $('#sameAsCustomer').prop('checked', false);

        alert('Please Select Customer');
      }
    } else {
      this.senderName = '';
      // this.senderNumber = '';
      $('#sendernumber').val('');
      $('#receivernumber').val('');
      $('#sendernumber, #sendername').attr('disabled', false);
      $('#sender_input').prop('checked', false);
      this.rec_name = '';
      this.rec_number = '';
      $('#receivername').val('');
      $('#receivernumber').val('');
      $('#receivernumber, #receivername').attr('disabled', false);
    }
    if (check) {
      setTimeout(() => {
        this.validate_form.element('#sendername');
        this.validate_form.element('#sendernumber');
      }, 100);
    }
  }

  // same as sender

  sameasSender() {
    event.preventDefault();
    if ($('#sender_input').is(':checked')) {
      if (
        this.senderName != '' &&
        this.senderName != undefined &&
        this.senderNumber != undefined
      ) {
        const countryData = $('#sendernumber').intlTelInput(
          'getSelectedCountryData'
        ).dialCode;
        // const countryData_id = $('#sendernumber').intlTelInput('getSelectedCountryData').iso2;
        // const classes = $('.receiver_number_parent2 .iti-flag').attr('class').split(' ');
        // $('.receiver_number_parent2 .selected-dial-code').text('+' + countryData);
        // $('.receiver_number_parent2 .iti-flag').removeClass(classes[1]);
        // $('.receiver_number_parent2 .iti-flag').addClass(countryData_id);
        // // $("#receivernumber").val('+'+countryData);
        // // console.log("countrydataq---->",countryData);
        // this.rec_name = this.senderName;
        // this.rec_number = this.senderNumber;
        // $('#sender_input').attr('checked', true);
        const senderNumber = $('#sendernumber').val();
        // console.log('sender name and number', senderNumber, countryData);
        const Numbers = `+${countryData}${senderNumber}`;
        $('#receivernumber').intlTelInput('setNumber', Numbers);
        this.rec_name = this.senderName;
        // setTimeout(() => {
        //   let mobile = $("#sendernumber").val();
        //   mobile = mobile.replace(/\s/g, '');
        //   // mobile = mobile.join();
        //   console.log(mobile);
        //   $("#sendernumber").val(mobile);
        // }, 100);
        $('#sender_input').prop('checked', true);
        $('#receivernumber, #receivername').attr('disabled', true);
      } else {
        $('#sender_input').prop('checked', false);
        alert('please fill both sender name and number');
      }
    } else {
      this.rec_name = '';
      this.rec_number = '';
      $('#receivername').val('');
      $('#receivernumber').val('');
      $('#receivernumber, #receivername').attr('disabled', false);
    }
    setTimeout(() => {
      this.validate_form.element('#receivername,#receivernumber');
      this.validate_form.element('#receivernumber');
    }, 100);
  }

  // change_payment(val) {
  //   $('#s-option'+val).trigger('click');
  //   this.payment_type = val;
  // }
  customerPayment(val) {
    if (val == 1) {
      // cash payment type
      $('#s-option4').trigger('click');
      this.credit_no_book = false;
      this.show_cards = false;
      this.payment_type = 2;
    } else if (val == 2) {
      // card payment type
      $('#s-option5').trigger('click');
      this.show_cards = true;
      this.payment_type = 1;
    }
  }
  change_payment(val) {
    console.log('change_payment', val);
    // $('#s-option' + val).trigger('click');
    this.paidBy = val;
    if (val == 2) {
      $('#cbWalletBal').prop('checked', false);
      this.walletPay = 0;
      this.payment_type = 2;
      this.showAllPayments = false;
    } else {
      $('#s-option4').trigger('click');
      this.getallcards();
      this.walletPay = 0;
      this.payment_type = 2;
      this.showAllPayments = true;
    }
  }

  changeWallet() {
    const checkBool = $('#cbWalletBal').prop('checked');
    $('#cbWalletBal').prop('checked', !checkBool);
    if (!checkBool) {
      swal(
        'wallet!',
        'Trip amount will be deducted from the wallet!',
        'warning'
      );
      this.walletPay = 1;
    } else {
      this.walletPay = 0;
    }
  }
  checkWallet() {
    const checkBool = $('#cbWalletBal').prop('checked');
    if (checkBool) {
      swal(
        'wallet!',
        'Trip amount will be deducted from the wallet!',
        'warning'
      );
      this.walletPay = 1;
    } else {
      this.walletPay = 0;
    }
  }

  route(
    origin_place_id,
    destination_place_id,
    travel_mode,
    directionsService,
    directionsDisplay
  ) {
    if (!origin_place_id || !destination_place_id) {
      return;
    }
    directionsService.route(
      {
        origin: { placeId: origin_place_id },
        destination: { placeId: destination_place_id },
        travelMode: travel_mode
      },
      (response, status) => {
        if (status == 'OK') {
          const that = this;
          directionsDisplay.setDirections(response);
        } else {
          window.alert('Directions request failed due to ' + status);
        }
      }
    );
  }
  // BOOK NOW TIME WILL TAKE NOW TIME USING JAVASCRIPT
  book_now() {
    this.bookNow = false;
    //  $(".date_success_later").removeClass('has-success');
    $('#book_now_pop_button').addClass('active');
    $('.flatpickr').val('');
    this.appt_type = 1;
    this.addnew_job();
  }

  bookNow = false;
  book_now_trigger() {
    this.bookNow = true;
    $('#book_now_pop_button').addClass('active');
    $('.flatpickr').val('');
    this.addnew_job();
  }

  clearerror() {
    this.comment_error = false;
  }

  // customAlert(x, file_num, callback) {
  //   this.AWSService.config.accessKeyId = myGlobals.awsid;
  //   this.AWSService.config.secretAccessKey = myGlobals.awskey;
  //   const bucket = new this.AWSService.S3({ params: { Bucket: myGlobals.awsbucket } });
  //   const params = { Body: file_num, Key: file_num.name };
  //   bucket.upload(params, (err, data) => {
  //     this.photo[x] = data.Location;
  //     localStorage.setItem('photo', data.Location);
  //     callback();
  //   });
  //   // do callback when ready
  // }

  // addphoto() {
  //   $('.booking_loader_parent').show();
  //   let x = 0;
  //   const loopArray = (arr) => {
  //     this.customAlert(x, arr[x], () => {
  //       // set x to next item
  //       x++;
  //       // any more items in array? continue loop
  //       if (x < arr.length) {
  //         loopArray(arr);
  //       }
  //       else {
  //         this.livebooking();
  //       }
  //     });
  //   };
  //   loopArray(this.file);
  // }

  checkBidding() {
    $('#switch').toggleClass('hover');
    this.enableBidding = !this.enableBidding;
    if (!this.enableBidding) {
      this.approx_amount = this.temp_finalAmount;
      this.priceChanged(this.approx_amount, true);
    }
  }

  livebooking() {
    if (this.approx_amount <= 0) {
      console.log('this.approx_amount=->', this.approx_amount);
      // swal("Error", "Enter Valid Amount", "error");
      return;
    }
    this.job_loader = true;
    let pickupdate_timestamp, dropdate_timestamp;
    if (!this.bookNow) {
      pickupdate_timestamp = moment(
        this.pickupdate,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD HH:mm:ss');
      dropdate_timestamp = moment(this.dropdate, 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD HH:mm:ss'
      );
    }
    const receiverCountryCode = $('#receivernumber').intlTelInput(
      'getSelectedCountryData'
    ).dialCode;
    const senderCountryCode = $('#sendernumber').intlTelInput(
      'getSelectedCountryData'
    ).dialCode;

    let length;
    let width;
    let height;
    // const senderNumberWithCountryCode = '+' + senderCountryCode + this.senderNumber;
    const senderNumberWithCountryCode = $('#sendernumber').intlTelInput(
      'getNumber'
    );
    let receiverNumber = $('#receivernumber').intlTelInput('getNumber', {
      nationalMode: true
    });
    receiverNumber = receiverNumber.replace(/\s/g, '');
    // const recnum = $('#receivernumber').val();
    console.log(senderNumberWithCountryCode, receiverNumber.replace(/\s/g, ''));
    if (this.product_lgt != '') {
      length = this.product_lgt + this.dimensionUnit;
    } else {
      length = '';
    }
    if (this.product_ht != '') {
      height = this.product_ht + this.dimensionUnit;
    } else {
      height = '';
    }
    if (this.product_wid != '') {
      width = this.product_wid + this.dimensionUnit;
    } else {
      width = '';
    }
    if (this.product_qty == undefined) {
      this.product_qty = '';
    }
    $('.booking_loader_parent').show();
    $('.select_cards').removeClass('has-error');
    const devid = this._cookie.getItem('devid');
    if (this.credit_no_book == true) {
      $('.booking_loader_parent').hide();
      $('#credit_popup_parent').show();
    } else {
      let cardId;
      if (this.payment_type == 1 && this.defaultcard != '') {
        cardId = this.defaultcard.id;
      } else {
        cardId = '';
      }

      if (this.payment_type == 1 && cardId == '') {
        this.job_loader = false;
        swal(
          'warning!',
          'Please add a card to continue the booking or select other payment type !',
          'error'
        );
      } else {
        if (!this.showWeight) {
          this.product_wgt = this.currentVehicleCapacity;
          this.metric_ton = 'Kg';
        }
        if (this.IsPriceFixed) {
          this.approx_amount = this.approx;
          // this.enableBidding = false;
        }
        let drop_time;
        if (this.bookNow) {
          drop_time = moment()
            .add(this.tripTimeInSeconds, 's')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        if ($('#f-option1').is(':checked')) {
          this.loadtype = 'LTL';
        } else {
          this.loadtype = 'FTL';
        }

        this._dispatcherService
          .postBooking({
            pickupAddress: this.pickupaddress.toString(),
            pickupLatitude: this.pickuplat.toString(),
            pickupLongitude: this.pickuplong.toString(),
            dropAddress: this.dropaddress.toString(),
            dropLatitude: this.droplat.toString(),
            dropLongitude: this.droplong.toString(),
            bookingDate: this.bookNow
              ? moment().format('YYYY-MM-DD HH:mm:ss')
              : pickupdate_timestamp,
            deliveryDate: this.bookNow ? drop_time : dropdate_timestamp,
            vehicleTypeId: this.vehicletypeid,
            vehicleType: this.vehiclename,
            receiverName: this.rec_name,
            receiverCountryCode: '+' + receiverCountryCode,
            receiverNumber: receiverNumber,
            customerName: this.senderName,
            customerNumber: senderNumberWithCountryCode,
            goodTypeId: this.goodstypeId,
            estimateId: this.fareEstimateDetails.estimateId.toString(),
            goodTypeName: this.goodstypeName,
            deliveryFee: this.codAmount ? this.codAmount.toString() : '',
            loadType: this.loadtype,
            weight: this.product_wgt.toString(),
            weightUnit: this.metric_ton.toString(),
            isEconomy: this.choosePrice || false,
            // 'amount': this.approx_amount ? this.approx_amount.toString() : this.approx,
            amount: this.finalHandlersPrice
              ? this.finalHandlersPrice.toString()
              : this.approx.toString(),
            paidBy: this.paidBy,
            paymentType: this.payment_type,
            payByWallet: this.walletPay,
            extraNotes: this.product_det,
            cardId: this.cardPayment ? this.card_number : '',
            // 'durationText': this.duration_txt,
            duration: this.duration,
            distance: this.distance.toString(),
            pickupCity: this.pickup_city_name,
            dropCity: this.drop_city_name,
            documents: this.file,
            bookingType: this.bookNow ? 1 : 2,
            deviceId: 'web',
            deviceType: 3,
            deviceTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            timeFare: this.timefee,
            distFare: this.distancefee,
            serviceType: 1,
            bidding: this.bookNow
              ? false
              : this.IsPriceFixed
                ? false
                : this.enableBidding,
            // 'bidding': this.IsPriceFixed ? false : this.enableBidding,
            // 'length': length,
            // 'height': height,
            // 'width': width,
            handlers: this.handlers.toString(),
            // 'quantity': this.product_qty,
            customerId: this.customer_id
          })
          .subscribe(
            (res: any) => {
              $('#form1')[0].reset();
              this.defaultcard = '';
              this.IsPriceFixed = false;
              this.clearCards();
              this.product_wgt = '';
              $('.booking_loader_parent').hide();
              $('#myModal').modal('hide');
              swal('Booking Confirmed!', res.message, 'success');
              this.job_loader = false;
              const data = {
                bookingId: res.data.bookingId,
                status: 1
              };
              // this._missionService.announceMission(JSON.stringify(data));
            },
            err => {
              console.log(err);
              $('.booking_loader_parent').hide();
              this.job_loader = false;
              if (err.status === 400) {
                swal('Error', err.error.message, 'error');
              } else if (err.status !== 400) {
                $('#myModal').modal('hide');
                $('#form1')[0].reset();
                $('#approx_distance').text(`...`);
                this.handleStatus(err.status, err.error);
                // toastr['error']('<h5>Could not connect to server!!! Please try again later</h5>')
              }
            }
          );
      }
    }
  }

  logged_out() {
    this._cookie.removeItem();
    this._router.navigate(['login']);
  }

  fileEvent(fileInput: any) {
    this.file = fileInput.target.files[0];
  }

  getmetricunit(e) {
    const value = e.target.value;
    if (this.metric_ton != 'Kg' || value != 'Kg') {
      this.product_wgt = '';
      $('#wght_value').val('');
      this.metric_ton = e.target.value;
      this.changeMaxWeight(this.metric_ton);
    }
    setTimeout(() => {
      this.validate_form.element('#wght_value');
    }, 100);
  }
  // TODO: Change the weight in placeholder as unit changes -- vivek
  changeMaxWeight(unit) {
    console.log('changeMaxWeight', unit);
    // console.log(unit, this.currentVehicleCapacityInUnits);
    if (this.currentVehicleCapacityInUnits) {
      if (unit == 'Kg') {
        this.currentVehicleCapacity = this.currentVehicleCapacityInUnits.inKg;
      } else if (unit == 'Pound') {
        this.currentVehicleCapacity = this.currentVehicleCapacityInUnits.inPound;
      } else if (unit == 'Tonne') {
        this.currentVehicleCapacity = this.currentVehicleCapacityInUnits.inTonne;
      }
    }
  }
  // price based on handlers --vivek
  getHandlers(e?) {
    this.handlers = this.handlers ? this.handlers : e.target.value;
    const handlers = this.handlers ? this.handlers : parseInt(e.target.value);
    const handlerPrice = handlers * this.perHandlersPrice;
    const initialPrice = parseFloat(this.approx);
    // this.approx = this.approx_amount;
    // this.approx_amount = parseFloat(this.approx) + handlerPrice;
    const temp = parseFloat(this.approx_amount);
    if (!isNaN(temp)) {
      this.finalHandlersPrice = parseFloat(this.approx_amount) + handlerPrice;
      this.finalHandlersPrice = this.finalHandlersPrice.toFixed(2);
    }
    // console.log('No of Handlers && Price-->', handlers, this.approx_amount, handlerPrice);
  }

  priceChanged(e, trigger = false) {
    if (!trigger) {
      const price = parseInt(e.target.value);
      if (price <= 0) {
        swal('Error', 'Enter Valid Amount', 'error');
      } else {
        if (!isNaN(price)) {
          const handlerPrice = this.handlers * this.perHandlersPrice;
          this.finalHandlersPrice = price + handlerPrice;
          this.finalHandlersPrice = this.finalHandlersPrice.toFixed(2);
        }
      }
    } else {
      const handlerPrice = this.handlers * Number(this.perHandlersPrice);
      this.finalHandlersPrice =
        Number(this.temp_finalAmount) + Number(handlerPrice);
      this.finalHandlersPrice = this.finalHandlersPrice.toFixed(2);
    }
  }

  onChange(event) {
    const event_file = event;
    let file_name = $('#file_input').val();
    file_name = file_name.replace(/[{()}]/g, '');
    const regex = /^([a-zA-Z0-9\s_\\.:])+(.csv|.txt|.xlsx)$/;
    if (regex.test(file_name.toLowerCase())) {
      if (typeof FileReader != 'undefined') {
        const reader = new FileReader();
        reader.onload = e => {
          const file = event_file.srcElement.files;
          const postData = {
            ent_sess_token: localStorage.getItem('authToken'),
            ent_dev_id: localStorage.getItem('devid')
          }; // Put your form data variable. This is only example.
          $('#file_input').val('');
          $('#bulk_close_btn').trigger('click');
        };
        reader.readAsText($('#file_input')[0].files[0]);
      } else {
        alert('This browser does not support HTML5.');
      }
    } else {
      alert('Please upload a valid CSV file.');
      $('#file_input').val('');
      $('#file_input').focus();
    }
  }

  clearCards() {
    this.allcards = [];
    this.card_number = '';
    this.default_card = [];
  }
  show_raing_txt(rate) {
    this.show_highrate_comment = false;
    this.high_rating = '';
    this.rating_num = rate;
    this.show_select = false;
    this.rating_error = false; // hide error if any
    if (rate < 4) {
      $('input[name=selector_review]').val(
        $('input[name=selector_review] option:first').val()
      );
      this.rating_text = [];
      this.show_low_rating = true;
      this.show_high_rating = false;
      for (const key in this.driver_rating) {
        if (key == rate) {
          this.rating_text = this.driver_rating[key];
          break;
        }
      }
    } else {
      this.rating_text = [];
      this.show_low_rating = false;
      this.show_high_rating = true;
      this.show_select = true;
      for (const key in this.driver_rating) {
        if (key == rate) {
          this.rating_text = this.driver_rating[key];
          break;
        }
      }
    }
  }

  // trigger a function when vehicletypes changes and stores id and name in variables
  // for post jobs service
  // and for getting goodstypes list variable to reflect on booking popup
  choosePrice: any;
  change_priceSelection(val, vehicleData,index) {
    console.log('val', val, event);
    if (val == 1) {
      $('#expressPriceOption' + index).trigger('click');
      $('.expressPriceOption' + index).show();
      $('.economyPriceOption' + index).hide();
      $('#est_journey').text(this.currency + vehicleData.finalAmount.toFixed(2));
      this.distancefee = this.fareEstimateDetails.distanceFee;
      this.distance = this.fareEstimateDetails.distance;
      this.timefee = this.fareEstimateDetails.timeFee;
      this.approx = this.fareEstimateDetails.finalAmount.toString();
      this.approx_amount = this.fareEstimateDetails.finalAmount;
      this.currency = this.fareEstimateDetails.currencySymbol;
      this.choosePrice = false;
      this.handlers ? this.getHandlers() : '';
    }
    else if (val == 2) {
      $('.economyPriceOption' + index).show();
      $('.expressPriceOption' + index).hide();
      $('#economyPriceOption' + index).trigger('click');
      $('#est_journey').text(this.currency + vehicleData.delivery.economyFee.toFixed(2));
      this.distancefee = this.fareEstimateDetails.distanceFee;
      this.distance = this.fareEstimateDetails.distance;
      this.timefee = this.fareEstimateDetails.timeFee;
      this.approx = vehicleData.delivery.economyFee.toString();
      this.approx_amount = vehicleData.delivery.economyFee;
      this.choosePrice = true;
      this.handlers ? this.getHandlers() : '';
    }
  }
get_vehicletypes(vehicleData,index) {
    // const vehicletypeid = $('#vehicle_types option:selected').val();
    const vehicletypeid = $(`input[name='vehicleType']:checked`).val();
    this.vehicletypeid = vehicletypeid;
    console.log(this.vehicle_types);
    this.fareEstimate(vehicleData);
    this.getVehicles();
    // this.getFavoriteDriver();
    this.vehicle_types.map((vehicleItem) => {
      vehicleItem['checked'] = false;
    });
    this.vehicle_types[index].checked = true;
    setTimeout(() => {
      vehicleData.delivery.economyFee < vehicleData.finalAmount ? this.change_priceSelection(1, this.vehicle_types[index], index) : '';
    }, 1000);
    for (let goods = 0; goods < this.vehicle_types.length; goods++) {
      if (this.vehicle_types[goods]._id == vehicletypeid) {
        // this.vehicle_types[goods].checked = true;
        this.goods_type_list = this.vehicle_types[goods].goodTypesName;
        this.vehicletypeid = this.vehicle_types[goods]._id;
        this.vehiclename = this.vehicle_types[goods].type_name;
        break;
      }
    }
  }

  goodschange() {
    const goodstype = $('#goodstype_selection option:selected').val();
    this.goodstypeId = goodstype;
    this.goodstypeName = $('#goodstype_selection option:selected').text();
  }
  showWeight = true;
  change_qty(val, event?) {
    console.log('change_qty', event);
    if (event) {
      event.stopPropagation();
    }
    if (val == 0) {
      this.loadtype = 'LTL';
      // $('#f-option1').trigger('click');
      this.showWeight = true;
      this.changeMaxWeight('Kg');
      this.metric_ton = 'Kg';
      $('#wght_value').val('');
    } else {
      this.loadtype = 'FTL';
      this.showWeight = false;
      // $('#f-option2').trigger('click');
      // console.log('FTL');
      this.changeMaxWeight('Kg');
      this.metric_ton = 'Kg';
    }
  }

  currentlat() {
    if (navigator.geolocation) {
      const options: PositionOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };
      const success: PositionCallback = pos => {
        console.log(pos);
        const crd = pos.coords;
        this.current_lat = crd.latitude;
        this.current_lng = crd.longitude;
      };
      const error: PositionErrorCallback = err => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        const positionData = JSON.parse(this._cookie.getConfig('ipinfo'));
        // const positionData = JSON.parse(sessionStorage.getItem('ipinfo'));
        this.current_lat = positionData.latitude;
        this.current_lng = positionData.longitude;
      };
      navigator.geolocation.getCurrentPosition(success, error, options);
    } else {
      const positionData = JSON.parse(this._cookie.getConfig('ipinfo'));
      // const positionData = JSON.parse(sessionStorage.getItem('ipinfo'));
      this.current_lat = positionData.latitude;
      this.current_lng = positionData.longitude;
    }
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(data => {
    //     console.log(data);
    //     this.current_lat = data.coords.latitude;
    //     this.current_lng = data.coords.longitude;
    //   });
    // } else {
    //   jQuery.get('https://ipapi.co/json/').always((res: any) => {
    //     if (res.status >= 400 || res.error) {
    //       jQuery.get('https://ipinfo.io', (response) => {
    //         this.current_lat = (response.loc).split(',')[0];
    //         this.current_lng = (response.loc).split(',')[1];
    //       }, 'jsonp');
    //     } else {
    //       this.current_lat = res.latitude;
    //       this.current_lng = res.longitude;
    //     }
    //   });
    // }                     // get current lat long using ipinfo
  }

  removepickupmarker() {
    // remove pickupmarker
    if (this.pickup_marker_loc !== undefined) {
      this.pickup_marker_loc.setMap(null);
    }
  }

  showpickupmarker() {
    // show pickupmarker
    const pos = new google.maps.LatLng(this.pickuplat, this.pickuplong);
    this.pickup_marker_loc = new google.maps.Marker({
      position: pos,
      icon: myGlobals.pickupicn,
      map: this.map,
      draggable: true
    });
    if (this.droplat !== undefined) {
      this.drawroute();
    }
    google.maps.event.addListener(this.pickup_marker_loc, 'dragend', () => {
      this.pickuplat = this.pickup_marker_loc.position.lat();
      this.pickuplong = this.pickup_marker_loc.position.lng();
      this.checkpickup();
    });
    this.mappickup_drop_bounds = new google.maps.LatLngBounds();
    this.mappickup_drop_bounds.extend(this.pickup_marker_loc.getPosition());
    this.map.fitBounds(this.mappickup_drop_bounds);
    this.map.setZoom(17);
  }

  // Fare Estimate All fun to get all vehicel fare's by Vivek on 20/jun/2019
  fareEstimateAll() {
    // console.log(this.pickuplat, this.pickuplong, this.droplat, this.droplong);
    if (this.pickuplat && this.pickuplong && this.droplat && this.droplong) {
      $(`#orbit-spinner`).fadeIn();
      this._dispatcherService
        .fareEstimateAll({
          pickupLatLong:
            this.pickuplat.toString() + ',' + this.pickuplong.toString(),
          dropLatLong: this.droplat.toString() + ',' + this.droplong.toString(),
          pickup: this.pickupaddress.toString(),
          drop: this.dropaddress.toString(),
          bookingType: this.bookNow ? 1 : 2,
          serviceType: 1,
          customerId: this.customer_id
        })
        .subscribe(
          (res: any) => {
            console.log('fareEstimateAll', res);
            this.fareEstimateDetails = res.data;
            this.distance = res.data.distance;
            this.currencyAbbr = res.data.currencyAbbr;
            this.distance_text = `${res.data.distance} ${res.data.distanceMetrics}`;
            res.data.vehicleTypeArray.map((item) => {
              item.finalAmount = parseFloat(item.finalAmount);
              item.delivery.economyFee = parseFloat(item.delivery.economyFee);
              item['checked'] = false;
            });
            this.vehicle_types = res.data.vehicleTypeArray;
            this.currency = res.data.currencySymbol;
            this.perHandlersPrice = res.data.perHandlersPrice;
            this.tripTimeInSeconds = res.data.tripTimeInSeconds;
            this.duration = res.data.duration;
            this.duration_txt = res.data.duration;
            this.handlersArr = [];
            for (let index = 1; index <= 10; index++) {
              const temp = `${index} Handlers  @ ${this.currency} ${index * this.perHandlersPrice}`;
              this.handlersArr.push(temp);
            }
            // this.duration_txt = res.data.duration;
            // $('#approx_distance').text(`${res.data.distance} ${res.data.distanceMetrics}`);
            $(`#orbit-spinner`).fadeOut();
            setTimeout(() => {
              $(`#vehicleTypeContainer`).trigger('click');
            }, 400);
          },
          err => {
            this.handleStatus(err.status, err.error);
          }
        );
    }
  }

  fareEstimate(vehicleData?) {
    console.log(vehicleData);
    // this.IsPriceFixed = false;
    // this.distancefee = vehicleData.distanceFee;
    // this.timefee = vehicleData.timeFee;
    // this.IsPriceFixed = vehicleData.fixedPriceApplied === 1 ? true : false;
    // this.approx = vehicleData.finalAmount.toString();
    // this.approx_amount = vehicleData.finalAmount;
    // this.temp_finalAmount = vehicleData.finalAmount;
    // if (this.currencyAbbr == 1) {
    //   $('#est_journey').text(`${this.currency} ${vehicleData.finalAmount}`);
    // } else {
    //   $('#est_journey').text(`${vehicleData.finalAmount} ${this.currency}`);
    // }
    // this.currentVehicleCapacity = vehicleData.vehicleCapacityInUnits.inKg;
    // this.currentVehicleCapacityInUnits = vehicleData.vehicleCapacityInUnits;
    // this.product_wgt = '';
    // $('#wght_value').val('');
    // this.metric_ton = 'Kg';
    // $('#weight_units>option:eq(0)').prop('selected', true);

    // Commented out infavour of fareestimateALL API

    this.fareEstimateDetails = [];
    console.log('customer id-->', this.customer_id, this.vehicletypeid, this.vehicle_types);
    this._dispatcherService.fareEstimate({
      'pickupLatLong': this.pickuplat.toString() + ',' + this.pickuplong.toString(),
      'dropLatLong': this.droplat.toString() + ',' + this.droplong.toString(),
      'pickup': this.pickupaddress.toString(),
      'drop': this.dropaddress.toString(),
      'bookingType': this.bookNow ? 1 : 2,
      'vehicleTypeId': this.vehicletypeid,
      'serviceType': 1,
      'customerId': this.customer_id
    }).subscribe((res: any) => {
      if (res.message !== 'Success.') {
        console.log(res.message);
        toastr['error'](res.message);
      } else {
        console.log(res);
        this.duration = res.data.duration;
        this.fareEstimateDetails = res['data'];
        this.perHandlersPrice = res.data.perHandlersPrice;
        this.tripTimeInSeconds = res.data.tripTimeInSeconds;
        this.IsPriceFixed = res.data.fixedPriceApplied === 1 ? true : false;
        console.log(this.IsPriceFixed);
        this.fareEstimateDetails = res.data;
        this.distancefee = res.data.distanceFee;
        this.distance = res.data.distance;
        this.distance_text = `${res.data.distance} ${res.data.distanceMetrics}`;
        this.timefee = res.data.timeFee;
        this.approx = res.data.finalAmount.toString();
        this.approx_amount = res.data.finalAmount;
        this.currency = res.data.currencySymbol;
        $('#est_journey').text(`${res.data.currencySymbol} ${res.data.finalAmount}`);
        if (parseFloat(res['data'].finalAmount) > parseFloat(res['data'].vehicleTypeDetails.delivery.economyFee)) {
          this.distancefee = res['data'].distanceFee;
          this.timefee = res['data'].timeFee;
          this.approx = res['data'].finalAmount.toString();
          this.approx_amount = res['data'].finalAmount;
          $('#est_journey').text(res['data'].currencySymbol + res['data'].finalAmount);
        }
        const vehicleId = this.vehicletypeid;
        const vechiclesData = this.vehicle_types;
        const currentVehicleData: any = vechiclesData.filter(data => data.typeId == vehicleId);
        this.currentVehicleCapacity = currentVehicleData[0].vehicleCapacityInUnits.inKg;
        this.currentVehicleCapacityInUnits = currentVehicleData[0].vehicleCapacityInUnits;
        this.product_wgt = '';
        $('#wght_value').val('');
        this.metric_ton = 'Kg';
        $('#weight_units>option:eq(0)').prop('selected', true);
      }
    }, (err) => {
      const error = JSON.parse(err.error);
      toastr['error'](error.message);
      const listErr = error.statusCode;
      this.handleStatus(err.status);
    }
    );
  }

  postBooking() { }
  getVehicles() {
    this.goods_type_list = [];
    this._dispatcherService
      .getGoodstypes({
        vehicleTypeId: this.vehicletypeid
      })
      .subscribe(
        (res: any) => {
          for (let inst = 0; inst < res.data.length; inst++) {
            this.goods_type_list.push(res.data[inst]);
          }
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  // check for pickup
  checkzone_one() {
    // console.log('customer id-->', this.customer_id);

    this.isCardEnable = false;
    this.isCardEnable = false;
    this.isWalletEnable = false;
    this.vehicle_types = []; // checkfor pickupzone
    $("label[for='origin-input2']").text('Checking location'); // alert message
    $('#map_loader_parent').show(); // loader showing
    this.clear_all_distance();
    this._dispatcherService
      .zone({
        latitude: this.pickuplat,
        longitude: this.pickuplong,
        customerId: this.customer_id
        // "mqttTopic": this._cookie.getItem('mqtt'),
      })
      .subscribe(
        (res: any) => {
          // console.log('Vechicle data', res);
          if (res.data.vehicleTypes.length > 0) {
            // this.showAllPayments = true;
            this.isCardEnable = res.data.cityData.isCardEnable;
            this.isCashEnable = res.data.cityData.isCashEnable;
            this.isPaidByReceiverEnable =
              res.data.cityData.isPaidByReceiverEnable;
            this.isWalletEnable = res.data.walletData.isWalletEnable;
            // Commented in favour of FareEstimateALl API
            // for (let inst = 0; inst < res.data.vehicleTypes.length; inst++) {
            //   this.vehicle_types.push(res.data.vehicleTypes[inst]);
            // }
            // console.log('vehicle types-->', this.vehicle_types);
            this.removepickupmarker();
            $("label[for='origin-input2']").remove();
            $('#map_loader_parent').hide();
            this.pickup_loader = false;
            if (res.errFlag == 1) {
              this.pickup_bool = false;
              this.showAllPayments = false;
              $('#origin-input2')
                .closest('.form-group')
                .removeClass('has-success')
                .addClass('has-error');
              $('#error_popup_parent').show();
              $('#origin-input2').val('');
              $('#origin-input2').focus('');
            } else {
              this.pickup_bool = true;
              this.pickup_loc_bool = true;
              this.showpickupmarker();
            }
          } else {
            this.pickup_loc_bool = false;
            this.pickup_bool = false;
            this.removepickupmarker();
            $('#map_loader_parent').hide();
            $('#error_popup_parent').show();
            this.pickup_loader = false;
            $('#origin-input2').val('');
            $("label[for='origin-input2']").text('Please enter valid location');
            $('#origin-input2')
              .closest('.form-group')
              .removeClass('has-success')
              .addClass('has-error');
          }
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  checkzone_two() {
    // checkfor droptwo  and draw lat longs
    $("label[for='origin-input3']").text('Checking location');
    $('#map_loader_parent').show();
    this.clear_all_distance();
    this._dispatcherService
      .zone({
        latitude: this.droplat,
        longitude: this.droplong,
        mqttTopic: this._cookie.getItem('mqtt')
      })
      .subscribe(
        (res: any) => {
          $("label[for='origin-input3']").remove();
          $('#map_loader_parent').hide();
          $('.loader_place2').hide();
          if (res.data.vehicleTypes.length == 0) {
            $('#origin-input3')
              .closest('.form-group')
              .removeClass('has-success')
              .addClass('has-error');
            $('#error_popup_parent').show();
            $('#origin-input3').val('');
            $('#origin-input3').focus('');
          } else {
            this.drawroute();
            this.drop_loc_bool = true;
            $('#origin-input3')
              .closest('.form-group')
              .removeClass('has-error')
              .addClass('has-success');
            if (this.pickup_bool && this.drop_bool) {
              this.vehicle_type_load = true;
            }
          }
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  checkpickup() {
    // when marker on map moved get location
    const geocoder = new google.maps.Geocoder();
    const infowindow = new google.maps.InfoWindow();
    const latlng = {
      lat: parseFloat(this.pickuplat),
      lng: parseFloat(this.pickuplong)
    };
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status == 'OK') {
        if (results[0]) {
          this.map.setZoom(17);
          $('#origin-input2').val(results[0].formatted_address);
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

      if (this.droplat !== undefined) {
        this.drawroute();
      }
      this.checkzone_one();
    });
  }

  drawroute() {
    $('.loader_place2').hide();
    this.clear_all_distance(); // Clear all the vechicles when changing pickup or drop
    const origin = new google.maps.LatLng(this.pickuplat, this.pickuplong); // using pickuplat
    const destination = this.droplat + ', ' + this.droplong; // using droplat long
    const directionsService2 = new google.maps.DirectionsService({
      preserveViewport: true
    });
    const request = {
      origin: origin, // LatLng|string
      destination: destination, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING // TRAVEL MODE
    };
    directionsService2.route(request, (response, status) => {
      if (status == 'OK') {
        const trip_distance = response.routes[0].legs[0].distance;
        // const trip_time = response.routes[0].legs[0].duration;
        // this.distance = trip_distance.value;
        // this.distance_text = trip_distance.text;
        // this.duration = trip_time.value;
        const point = response.routes[0].legs[0]; // SHOWING MAP ROUTE ZOOM BASED ON APPROX DIST
        this.journey_time = point.distance.value;
        this.journey_time = this.journey_time / 1000;
        this.directionsDisplay.setDirections(response);
        this.directionsDisplay.setMap(this.map); // DRAWING MAP ROUTES FROM PICKUP AND DROP FROM RESULT
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(
          this.map,
          'bounds_changed',
          event => {
            this.map.panToBounds(this.mappickup_drop_bounds);
            if (this.journey_time <= 100) {
              this.map.setZoom(13);
            } else if (this.journey_time > 100 && this.journey_time < 500) {
              this.map.setZoom(9);
            } else if (this.journey_time > 500 && this.journey_time < 1500) {
              this.map.setZoom(7);
            } else if (this.journey_time > 1500) {
              this.map.setZoom(6);
            }
            google.maps.event.trigger(this.map, 'resize');
          }
        );
        setTimeout(function () {
          google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000);
      }
    });

    // END OF TIME CALCULATION GOOGLE API
  }

  change_dimensions_unit() {
    const selected_value = $('select#dimenstions')
      .children(':selected')
      .val();
    this.dimensionUnit = selected_value;
  }
  checkdrop() {
    const geocoder = new google.maps.Geocoder();
    const infowindow = new google.maps.InfoWindow();
    const latlng = {
      lat: parseFloat(this.droplat),
      lng: parseFloat(this.droplong)
    };
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status == 'OK') {
        if (results[0]) {
          this.map.setZoom(17);
          $('#origin-input3').val(results[0].formatted_address);
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
      this.drawroute();
      this.drop_loc_bool = true;
      $('#origin-input3')
        .closest('.form-group')
        .removeClass('has-error')
        .addClass('has-success');
      if (this.pickup_bool && this.drop_bool) {
        this.vehicle_type_load = true;
      }
      $("label[for='origin-input3']").remove();
      $('#map_loader_parent').hide();
      $('.loader_place2').hide();
      // this.checkzone_two()
      this.drop_loc_bool = true;
      $('#origin-input3')
        .closest('.form-group')
        .removeClass('has-error')
        .addClass('has-success');
      if (this.pickup_bool && this.drop_bool) {
        this.vehicle_type_load = true;
        // this.getVechicles();
      }
    });
  }
  clear_all_distance() {
    this.distance_text = '....';
    this.duration_txt = '....';
  }
  //   clear_all_vehicles() {
  //     this.vehicle_types = [];
  //     this.duration = [];
  //     this.approx_dist_txt = [];
  //     this.approx = [];
  // }

  get_dates(laterTime) {
    let StartDate;
    this.current_time = new Date();
    this.current_time_var =
      this.current_time.getFullYear() +
      '-' +
      ('0' + (this.current_time.getMonth() + 1)).slice(-2) +
      '-' +
      this.current_time.getDate() +
      ' ' +
      this.current_time.getHours() +
      ':' +
      this.current_time.getMinutes() +
      ':' +
      this.current_time.getSeconds();
    const startDate = moment().add(parseInt(laterTime), 'seconds');
    flatpickr('.flatpickr', {
      // defaultDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'), // Date objects and date strings are also accepted
      enableTime: true,
      minDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'), // "today" / "2016-12-20" / 1477673788975
      altInput: true,
      onChange: (selectedDates, dateStr, instance) => {
        // console.log(selectedDates, dateStr, instance);
        setTimeout(() => {
          let calendar = $('.flatpickr').val();
          calendar = moment(calendar).add(this.tripTimeInSeconds, 's');
          calendar = moment(calendar).format('YYYY-MM-DD HH:mm:ss');
          console.log('calender==>>', calendar);
          // this.validate_form.element('.flatpickr');
          flatpickr('.flatpickr2', {
            // defaultDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
            minDate: calendar, // Date objects and date strings are also accepted
            enableTime: true,
            altInput: true,
            onChange: () => {
              // this.validate_form.element('.flatpickr2');
            }
          });
        }, 500);
      }
    });
    StartDate = moment(startDate).add(2, 'h');
    flatpickr('.flatpickr2', {
      // defaultDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'), // Date objects and date strings are also accepted
      enableTime: true,
      minDate: moment(StartDate).format('YYYY-MM-DD HH:mm:ss'),
      // altFormat: 'M j, Y',
      altInput: true,
      onChange: () => { }
    });
    this.pickupdate = '';
  }
  addnew_job() {
    this.resetForm();
    if (!this.current_lat && !this.current_lng) {
      this.currentlat();
    }
    this.current_lat = -28.4793;
    this.current_lng = 24.6727;
    setTimeout(() => {
      const currentPosition = {
        lat: this.current_lat ? this.current_lat : 12.9716,
        lng: this.current_lng ? this.current_lng : 77.5946
      };
      console.log('currentPosition--->', currentPosition);
      // this.wallet();
      this.appconfig();
      // this.get_dates();
      $('.popup_left_div').animate({ scrollTop: 0 }, 100); // scrolls to top
      const popup_ht = $('.popup_left_div').height(); // takes height of popup
      $('.popup_right_div').css('height', popup_ht); // gives height to popup right div
      $('#f-option1').prop('checked', true);
      $('#f-option2').prop('checked', false);
      this.showWeight = true;
      let origin_place_id = null;
      const destination_place_id = null;
      const travel_mode = 'DRIVING';
      const map = new google.maps.Map(document.getElementById('map2'), {
        // inst.. map when popup opens
        mapTypeControl: false,
        center: currentPosition, // current latlongs used from ipinfo
        zoom: 5,
        disableDefaultUI: true,
        zoomControl: true
      });
      this.map = map;
      map.setOptions({
        // setoptions with styles_common
        styles: mapStyle[0],
        minZoom: 2,
        maxZoom: 20
      });
      const directionsService = new google.maps.DirectionsService();
      const directionsDisplay = new google.maps.DirectionsRenderer({
        suppressMarkers: true
      });
      directionsDisplay.setMap(map);
      const origin_input = document.getElementById('origin-input2');
      const destination_input = document.getElementById('origin-input3');
      const modes = document.getElementById('mode-selector');
      map.controls[google.maps.ControlPosition.TOP_LEFT].push();
      map.controls[google.maps.ControlPosition.TOP_LEFT].push();
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(modes);
      const origin_autocomplete = new google.maps.places.Autocomplete(
        origin_input
      );
      origin_autocomplete.bindTo('bounds', map);
      const destination_autocomplete = new google.maps.places.Autocomplete(
        destination_input
      );
      destination_autocomplete.bindTo('bounds', map);
      // Sets a listener on a radio button to change the filter type on Places
      // Autocomplete
      function expandViewportToFitPlace(map, place) {
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(5);
        }
      }
      if (origin_autocomplete) {
        // get pickup address and check whether it comes in zone or not
        origin_autocomplete.addListener('place_changed', () => {
          $('#vehicle_types').prop('selectedIndex', 0);
          $('.flatpickr').val('');
          $('.flatpickr2').val('');
          this.pickupdate = '';
          this.dropdate = '';
          const place = origin_autocomplete.getPlace();
          for (
            let city_add = 0;
            city_add < place.address_components.length;
            city_add++
          ) {
            if (place.address_components[city_add].types[0] == 'locality') {
              this.pickup_city_name =
                place.address_components[city_add].long_name;
              break;
            }
          }

          origin_place_id = place.place_id;
          this.pickuplat = place.geometry.location.lat();
          this.pickuplong = place.geometry.location.lng();
          this.checkzone_one();
          this.vehicles_empty = false;
          this.current_lat = place.geometry.location.lat();
          this.current_lng = place.geometry.location.lng();
          this.pickup_loader = true;
          $('#origin-input2')
            .closest('.form-group')
            .removeClass('has-error')
            .addClass('has-success');
          $("label[for='origin-input3']").remove();
          this.pickup_bool = true;
          this.show_error_bool = true;
          this.checking_vehs = true;
          this.pickupaddress = place.formatted_address;
          origin_autocomplete.bindTo('bounds', map);
          this.fareEstimateAll();
          if (
            this.droplat !== '' &&
            this.droplat !== undefined &&
            this.vehicletypeid !== undefined &&
            this.vehicletypeid !== ''
          ) {
            // this.fareEstimate();
          }
        });
      }
      if (destination_autocomplete) {
        // checks whether dropzone in operational zone or not
        destination_autocomplete.addListener('place_changed', () => {
          $('#vehicle_types').prop('selectedIndex', 0);
          $('.flatpickr').val('');
          $('.flatpickr2').val('');
          this.pickupdate = '';
          this.dropdate = '';
          destination_autocomplete.bindTo('bounds', map);
          const place = destination_autocomplete.getPlace();
          this.droplat = place.geometry.location.lat();
          this.droplong = place.geometry.location.lng();
          this.dropaddress = place.formatted_address;
          this.fareEstimateAll();
          if (
            this.pickuplat !== '' &&
            this.pickuplat !== undefined &&
            this.vehicletypeid !== undefined &&
            this.vehicletypeid !== ''
          ) {
            // this.fareEstimate();
          }
          for (
            let city_add = 0;
            city_add < place.address_components.length;
            city_add++
          ) {
            if (place.address_components[city_add].types[0] == 'locality') {
              this.drop_city_name =
                place.address_components[city_add].long_name;
              break;
            }
          }
          $("label[for='origin-input3']").text('Checking location');
          if (this.drop_marker_loc !== undefined) {
            // if any previous drop marker remove that markers
            this.drop_marker_loc.setMap(null);
          }
          $('.loader_place2').show();
          this.drawroute();
          this.drop_loc_bool = true;
          $('#origin-input3')
            .closest('.form-group')
            .removeClass('has-error')
            .addClass('has-success');
          if (this.pickup_bool && this.drop_bool) {
            this.vehicle_type_load = true;
          }
          $("label[for='origin-input3']").remove();
          $('#map_loader_parent').hide();

          // this.checkzone_two();
          const veh_id = $('input[name=radio]:checked').attr('value');
          this.drop_bool = true;
          const pos = new google.maps.LatLng(this.droplat, this.droplong);
          this.drop_marker_loc = new google.maps.Marker({
            position: pos,
            icon: myGlobals.dropupicn,
            map: map,
            draggable: true
          });
          google.maps.event.addListener(this.drop_marker_loc, 'dragend', () => {
            this.droplat = this.drop_marker_loc.position.lat();
            this.droplong = this.drop_marker_loc.position.lng();
            this.checkdrop();
            // document.getElementById('lng').value = marker.position.lng();
          });
          this.mappickup_drop_bounds.extend(this.drop_marker_loc.getPosition());
        });
      }
      // $('.flatpickr').val('Pickup date');
      // $('.flatpickr2').val('');
    }, 300);
  }

  card_wallet_validate() {
    // add new card wallet validation
    $('#credit_form_validation').validate({
      rules: {
        username: {
          minlength: 3,
          required: true
        },
        month: {
          required: true
        },
        card_name: {
          required: true
        },
        cvv: {
          minlength: 3,
          required: true
        }
      },
      success: element => { },
      highlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
      },
      unhighlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-error')
          .addClass('has-success');
      },
      submitHandler: form => {
        this.stripe_cardadd();
      }
    });
  }
  // $.get('https://ipapi.co/json/', function (res: any) {
  //             console.log(res: any);
  //             const countryCode = (res && res.country) ? res.country : '';
  //             success(countryCode);
  //           });

  telephone_input_validate() {
    $('#sendernumber,#receivernumber,#phonenumber').intlTelInput({
      autoHideDialCode: true,
      geoIpLookup: (success, failure) => {
        const data = JSON.parse(this._cookie.getConfig('ipinfo'));
        // const data = JSON.parse(sessionStorage.getItem('ipinfo'));
        console.log(data);
        success(data.country);
        // $.get('https://ipapi.co/json/').always(function (res: any) {
        //   if (res.status >= 400 || res.error) {
        //     $.get('https://ipinfo.io', function () { }, 'jsonp').always(function (resp) {
        //       console.log(resp);
        //       const countryCode = (resp && resp.country) ? resp.country : '';
        //       success(countryCode);
        //     });
        //   } else {
        //     const countryCode = (res && res.country) ? res.country : '';
        //     success(countryCode);
        //   }

        // });
      },
      initialCountry: 'ZA',
      nationalMode: false,
      separateDialCode: true,
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js'
    });
    setTimeout(() => {
      this.initialCountryCode = $('#sendernumber').intlTelInput(
        'getSelectedCountryData'
      ).dialCode;
      this.initialCountryFlag = $('#sendernumber').intlTelInput(
        'getSelectedCountryData'
      ).iso2;
      // this.initialCountryCode = $('#phonenumber').intlTelInput('getSelectedCountryData').dialCode;
      // this.initialCountryFlag = $('#phonenumber').intlTelInput('getSelectedCountryData').iso2;
    }, 1000);

    const telInput = $('#phone'),
      errorMsg = $('#error-msg'),
      validMsg = $('#valid-msg');
    const reset = function () {
      telInput.removeClass('error');
      errorMsg.addClass('hide');
      validMsg.addClass('hide');
    };
    telInput.blur(function () {
      reset();
      if ($.trim(telInput.val())) {
        if (telInput.intlTelInput('isValidNumber')) {
          validMsg.removeClass('hide');
        } else {
          telInput.addClass('error');
          errorMsg.removeClass('hide');
        }
      }
    });
    $.validator.addMethod(
      'uniqueUserName',
      function (value, element) {
        if (telInput.intlTelInput('isValidNumber')) {
          return true;
        } else {
          return false;
        }
      },
      'Please enter valid number'
    );
  }
  weigthChange(e) {
    const inputWeightValue = parseFloat(e.target.value);
    const vehicleMaxWeight = parseFloat(this.currentVehicleCapacity);
    if (inputWeightValue > vehicleMaxWeight) {
      const weightEntered = inputWeightValue.toString();
      this.product_wgt = parseFloat(weightEntered.slice(0, -1));
      $('#wght_value').val(parseFloat(weightEntered.slice(0, -1)));
      // console.log(this.product_wgt);
      // console.log($('#wght_value').val());
      swal(
        'warning!',
        `Enter Less than ${vehicleMaxWeight} ${this.metric_ton}`,
        'error'
      );
    }
    setTimeout(() => {
      this.validate_form.element('#wght_value');
    }, 100);
  }

  jquery_func_trigger() {
    $('.vehicletypes_but').on('click', 'li', function () {
      $('#popup_dropdown:first-child').text($(this).text());
      $('#popup_dropdown:first-child').val($(this).text());
      this.vechicle_type = $(this).attr('id');
      localStorage.setItem('vechileType', this.vechicle_type);
    });
    $('#wght_value,#card-ccv').keypress(function (event) {
      const $this = $(this);
      if (
        (event.which !== 46 || $this.val().indexOf('.') !== -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which !== 0 && event.which !== 8))
      ) {
        event.preventDefault();
        const text = $($this).val();
        if (event.which == 46 && text.indexOf('.') == -1) {
          setTimeout(function () {
            if ($this.val().substring($this.val().indexOf('.')).length > 3) {
              $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
            }
          }, 1);
        }
        if (
          text.indexOf('.') !== -1 &&
          text.substring(text.indexOf('.')).length > 2 &&
          (event.which !== 0 && event.which !== 8) &&
          $(this)[0].selectionStart >= text.length - 2
        ) {
          event.preventDefault();
        }
      }
    });
    $('.input-cart-number').on('keyup change', $event => {
      $('.card_error_msg').remove();

      let card_number = '';
      $('.input-cart-number').each(function () {
        card_number += $(this).val() + ' ';
        if ($(this).val().length == 4) {
          let attrb = parseInt($(this).attr('data-attribute'));
          attrb++;
          $('#card-number-' + attrb).focus();
        }
      });
      this.card_number_all = card_number.replace(/ /g, '');
      this.GetCardType(this.card_number_all);
      $('.credit-card-box .number').html(card_number);
    });
    $('#card-holder').on('keyup change', function ($event) {
      $('.credit-card-box .card-holder div').html($event.target.value);
    });
    $('#card-expiration-month, #card-expiration-year').change($event => {
      $('.month_error_msg').remove();
      let m, y;
      m = $('#card-expiration-month option:selected').val();
      y = $('#card-expiration-year').val();
      if (y != null) {
        y = $('#card-expiration-year').val();
      } else {
        y = '';
      }
      $('.card-expiration-date div').html(m + '/' + y);
      const that = this;
      that.month_year(m, y);
    });

    $('#card-ccv')
      .on('focus', $event => {
        $('.credit-card-box').addClass('hover');
      })
      .on('blur', function () {
        $('.credit-card-box').removeClass('hover');
      })
      .on('keyup change', $event => {
        $('.ccv div').html($event.target.value);
        this.card_cvc = $event.target.value;
      });
    $('#add_popup_but').click(function () {
      // $("#contact-form").valid();
    });
    jQuery('#book_now_pop_button').trigger('click');
    $(function () {
      $(document.body).on('show.bs.modal', function () {
        $(document.body).addClass('modal-open');
      });
      $(document.body).on('hide.bs.modal', function () {
        $(document.body).removeClass('modal-open');
      });
    });
    jQuery('.phone_num_valid').keyup(function () {
      this.value = this.value.replace(/[^0-9\.]/g, '');
    });
    jQuery('#book_now_pop_button').click(function () {
      $('this').addClass('active');
    });
    jQuery('#right_front_div').hide();
    jQuery('.front_div_close').click(function () {
      jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').hide();
    });
    jQuery('#right_taks_but').click(function () {
      jQuery('.tasks_list_right').toggle();
    });
    jQuery('.connections_div').click(function () {
      jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').show();
    });
    jQuery('#job_details_button').trigger('click');
    jQuery('#bulk_import_but').click(function () {
      jQuery('#bulk_import_but')
        .find('span')
        .toggleClass('active');
    });
    $('#assigned_but').click(() => {
      $('#left_full_body').hide();
      this.passDetailsContent = [];
    });
    $('#un_assigned_but').click(() => {
      $('#left_full_body').show();
      this.passDetailsContent = [];
    });
    $('#completed_but').click(() => {
      $('#left_full_body').hide();
      this.passDetailsContent = [];
    });
    $('#origin-input2').change(() => {
      clearInterval(this.vehicles_interval);
      this.pickup_loc_bool = false;
    });
    $('#origin-input3').change(() => {
      clearInterval(this.vehicles_interval);
      this.drop_loc_bool = false;
    });
    jQuery('.width_3').click(function () {
      jQuery('.width_3').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('.width_3_rt').click(function () {
      jQuery('.width_3_rt').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery(document).keydown(e => {
      // ESCAPE key pressed
      if (e.keyCode == 27) {
        $('.modal').modal('hide');
      }
    });
    jQuery('.mute_onn').click(function () {
      // $(this).toggleClass("glyphicon-volume-up glyphicon-volume-off");
      // $(this).toggleClass("glyphicon-volume-off");
    });
    jQuery('.left_marker').click(function () {
      const k = jQuery('.left-window').width();
      const y = jQuery(window).width();
      const result = y - k;
      if (jQuery('.left-window').hasClass('open')) {
        jQuery('.left-window').animate({ left: -k });
        jQuery('.left-window').removeClass('open');
        jQuery('.icn_left').addClass('rotate_pointer');
        jQuery('#map>div').animate({ marginLeft: '0%' });
      } else {
        jQuery('.left-window').animate({ left: '0' });
        jQuery('.left-window').addClass('open');
        jQuery('.icn_left').removeClass('rotate_pointer');
        jQuery('#map>div').animate({ marginLeft: k });
      }
    });
    jQuery('.right_marker').click(function () {
      const k = jQuery('.left-window').width();
      const y = $(window).width();
      const result = y - k;
      if (jQuery('.right-window').hasClass('open')) {
        jQuery('.right-window').animate({ right: -k });
        jQuery('.right-window').removeClass('open');
        jQuery('.icn_right').addClass('rotate_pointer');
        jQuery('#map>div').animate({ width: '100%' });
      } else {
        jQuery('.right-window').animate({ right: '0' });
        jQuery('.right-window').addClass('open');
        jQuery('.icn_right').removeClass('rotate_pointer');
        jQuery('#map>div').animate({ width: result });
      }
    });
    $('#noservice_ok_but,#noservice_ok_but2').click(() => {
      this.show_error_bool = false;
      $('#error_popup_parent,#credit_popup_parent').hide();
    });
    $('#myModal').on('hidden.bs.modal', () => {
      // this.telephone_input_validate();

      // same as initial loading country flag
      // const classes = $('.receiver_number_parent2 .iti-flag').attr('class').split(' ');
      // const classes2 = $('.receiver_number_parent .iti-flag').attr('class').split(' ');
      // $('.receiver_number_parent2 .selected-dial-code, .receiver_number_parent .selected-dial-code').text('+' + this.initialCountryCode);
      // $('.receiver_number_parent2 .iti-flag').removeClass(classes[1]);
      // $('.receiver_number_parent .iti-flag').removeClass(classes2[1]);
      // $('.receiver_number_parent2 .iti-flag, .receiver_number_parent .iti-flag').addClass(this.initialCountryFlag);
      // // same as initial loading country flag
      // clearInterval(this.credit_line_interval);
      $('#origin-input2').val('');
      $('.form-group.has-feedback').removeClass('has-success');
      $('.remove_details input,textarea').val('');
      $('.img-ul-clear').trigger('click');
      $('#est_journey').text('...');
      this.zone_one_title = ' ';
      this.zone_two_title = ' ';
      this.vehicletypeid = '';
      this.product_wid = '';
      this.product_lgt = '';
      this.product_ht = '';
      this.handlers = 0;
      this.fareEstimateDetails = [];
      // this.currency = '...';
      this.product_qty = '';
      $('#est_journey').text('');
      $('#choose_file_span').text('');
      this.approx = '.....';
      this.approx_dist_txt = '';
      this.duration = '';
      this.card_number = '';
      this.droplat = '';
      this.droplong = '';
      this.rec_name = '';
      this.rec_number = '';
      this.paidBy = 1;
      this.payment_type = 2;
      this.distance_text = '....';
      this.duration_txt = '....';
      this.show_ratecard = false;
      this.isCardEnable = false;
      this.isCashEnable = false;
      this.isWalletEnable = false;
      clearInterval(this.vehicles_interval);
      $('#sender_input').attr('checked', false);
      $('#loader_place2').hide();
      $('.form-group').removeClass('has-error');
      $('.form-group').removeClass('has-success');
      $('label.error').remove();
      $('.multiple_img').hide();
      $('.ref_img1').show();
      $('.delete_photo_icn').hide();
      $('#upload1,#upload2,#upload3,#upload4,#upload5').attr(
        'src',
        './assets/img/image_upload.png'
      );
      this.file = [];
      // $('select[name=goodstype]').val($('select[name=goodstype] option:first').val());
      // $('select[name=handlers]').val($('select[name=handlers] option:first').val());
      // $('select[name=vehicletype]').val($('select[name=vehicletype] option:first').val());
      // $('select[name=handlers]').val($('select[name=handlers] option:first').val());
      // $('select[name=payment_method]').val($('select[name=payment_method] option:first').val());
      // $('#f-option2').trigger('click');
      // $('#s-option4').trigger('click');
      // $('#s-option1').trigger('click');
      $('#cbWalletBal').prop('checked', false);
      this.walletPay = 0;
      this.showAllPayments = false;
      this.new_customer = false; // card triggers
    });
    $('#addnew_but').click(() => {
      this.addnew_job();
    });
  }
  gMapKey;
  firstLoad = true;
  appconfig() {
    this._dispatcherService.appconfig({}).subscribe(
      (res: any) => {
        console.log('links', res)
        this.gMapKey = res.data.googleMapKey;
        this._cookie.setConfig(res.data);
        this.weightMetrics = res.data.weightMetrics;
        this.get_dates(res.data.shipmentLaterBookingAppBuffer);
        this.isBiddingEnabled = res.data.appSettings.bidding;
        this.isBookNowEnabled = res.data.appSettings.bookNow;
        this.isBookLaterEnabled = res.data.appSettings.bookLater;
        this.isReceiverConfirmationEnabled =
          res.data.appSettings.recieverConfirmation;
        this.isSecurityOtpIsEnabled = res.data.appSettings.securityOtp;
        this.metric_ton = 'Kg';
        $('#weight_units>option:eq(0)').prop('selected', true);
      },
      err => {
        this.job_loader = false;
        this.handleStatus(err.status, err.error);
      }
    );
  }

  wallet() {
    this._dispatcherService.wallet({}).subscribe((res: any) => {
      this._cookie.setWalletDetails(res.data);
      this.currency = res.data.currencySymbol;
      this.showing_balance = this._cookie.getWalletDetails('walletBalance');
      this.walletEnable = res.data.isEnabled;
    });
  }

  open_card_div() {
    if (this.allcards.length > 0) {
      this.hideNewcard();
    }
    $('#credit_card_popup').modal('show');
  }

  getallcards() {
    this.allcards = [];
    this.defaultcard = [];
    console.log('getallcards', this.customer_id);
    if (!this.customer_id) {
      return;
    }
    this._dispatcherService.getcards(this.customer_id).subscribe(
      (res: any) => {
        $('.loader_cardadd_parent').hide();
        if (res.data.cards.length > 0) {
          this.allcards = res.data.cards;
          this.defaultcard = res.data.cards.filter(card => card.isDefault)[0];
          $('#' + this.defaultcard.id).attr('checked', true);
          // for (let inst = 0; inst < res.data.cards.length; inst++) {
          //   this.allcards.push(res.data.cards[inst]);
          //   if (res.data.cards[inst].isDefault) {
          //     this.defaultcard = res.data.cards[inst];
          //     $('#' + this.allcards[inst].id).attr('checked', true);
          //   }
          // }
        } else {
          this.allcards = [];
          this.hideSelectcard();
          this.defaultcard = '';
        }
      },
      err => {
        this.handleStatus(err.status, err.error);
      }
    );
  }

  select_card(item) {
    this.defaultcard = item;
    $('.check_id' + item.id).prop('checked', true);
    $('.cash_cards').removeClass('active');
    $('.card_id' + item.id).addClass('active');
  }

  changeDefault(item) {
    this.defaultcard = item;
    $('.check_id' + item.id).prop('checked', true);
    $('.card_id' + item.id).addClass('active');
  }

  dcard(card) {
    this._dispatcherService
      .deletecard({
        cardId: card.id
      })
      .subscribe((res: any) => {
        swal('success!', 'Card deleted successfully !', 'success');
        // this.getallcards();
      });
  }

  hideSelectcard() {
    $('.card_buttons').removeClass('active');
    $('.add_card_button').addClass('active');
    $('#added_cards_div').hide(500);
    $('#new_cards_div').show(500);
    $('#card-number').focus();
    this.card_number_all = '';
  }
  hideNewcard() {
    $('.card_buttons').removeClass('active');
    $('.select_card_button').addClass('active');
    $('#new_cards_div').hide(500);
    $('#added_cards_div').show(500);
  }
  GetCardType(number) {
    this.visa = false;
    this.amex = false;
    this.discover = false;
    this.jcb = false;
    this.diners = false;
    this.master = false;
    // visa
    let re = new RegExp('^4');
    if (number.match(re) != null) {
      this.visa = true;
      return 'Visa';
    }
    // Mastercard
    re = new RegExp('^5[1-5]');
    if (number.match(re) != null) {
      this.master = true;
      return 'Mastercard';
    }
    // AMEX
    re = new RegExp('^3[47]');
    if (number.match(re) != null) {
      this.amex = true;
      return 'AMEX';
    }
    // Discover
    re = new RegExp(
      '^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)'
    );
    if (number.match(re) != null) {
      this.discover = true;
      return 'Discover';
    }
    // Diners
    re = new RegExp('^36');
    if (number.match(re) != null) {
      this.diners = true;
      return 'Diners';
    }
    // Diners - Carte Blanche
    re = new RegExp('^30[0-5]');
    if (number.match(re) != null) {
      this.diners = true;
      return 'Diners - Carte Blanche';
    }
    // JCB
    re = new RegExp('^35(2[89]|[3-8][0-9])');
    if (number.match(re) != null) {
      this.jcb = true;
      return 'JCB';
    }
    // Visa Electron
    re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
    if (number.match(re) != null) {
      this.visa = true;
      return 'Visa Electron';
    }
    return 'NOT';
  }
  stripe_cardadd() {
    $('.card_error_msg').remove();
    $('.month_error_msg').remove();
    const card =
      $('#card-number').val() +
      $('#card-number-1').val() +
      $('#card-number-2').val() +
      $('#card-number-3').val();
    const mm = $('#card-expiration-month option:selected').val();
    const yy = $('#card-expiration-year option:selected').val();
    if (card.length < 14 || mm == '00' || yy == '00') {
      if (card.length < 14)
        $('.card_number_valid').append(
          '<span class="card_error_msg">' +
          this.disphome.validCardNum +
          '</span>'
        );
      else
        $('.fieldset-expiration').append(
          '<span class="month_error_msg">' +
          this.disphome.validExpiry +
          '</span>'
        );
    } else {
      $('.card_error_msg').remove();
      $('.month_error_msg').remove();
      $('.loader_cardadd_parent').show();
      const stripekey = this._cookie.getConfig('stripe');
      Stripe.setPublishableKey(stripekey);
      Stripe.createToken(
        {
          number: parseInt(this.card_number_all),
          cvc: parseInt(this.card_cvc),
          exp_month: this.card_month.toString(),
          exp_year: this.card_year.toString()
        },
        (status, response) => {
          if (response['id'] !== undefined) {
            // this.addcards(response['id']);
            // this.getallcards();
          } else {
            $('.error_card_msg').css('color', 'red');
            $('.error_card_msg').text(response.error.message);
            setTimeout(() => {
              $('.error_card_msg').text('');
            }, 2000);
            $('.loader_cardadd_parent').hide();
          }
        }
      );
    }
  }

  month_year(m, y) {
    this.card_month = m;
    this.card_year = y;
  }
  usecard() {
    const cardid = $('input[name=card_select]:checked').val();
    if (cardid == undefined) {
      alert('please select a card');
    } else {
      this.card_number = $('input[name=card_select]:checked').val();
      $('.card_block').removeClass('has-error');
      $('.card_block').addClass('has-success');
      $('#credit_card_popup').modal('hide');
    }
  }

  // Reset Form by vivek
  resetForm() {
    this.handlersArr = [];
    this.customer_id = '';
    this.temp_finalAmount = '';
    this.newCustAdd = true;
    this.codAmount = '';
    this.choosePrice = '';
    // console.log('model hidden')
    // this.clearCards();
    this.goods_type_list = [];
    this.vehicle_types = [];
    $('#form1')[0].reset();
    $('#f-option1').prop('checked', true);
    $('#f-option2').prop('checked', false);
    this.allcards = [];
    this.card_number = '';
    this.default_card = [];
    this.defaultcard = '';
    this.show_cards = false;
    this.cardPayment = false;
    this.loadtype = 'LTL';
    this.showAllPayments = false;
    this.IsPriceFixed = false;
    this.change_qty(0);
    this.currentVehicleCapacityInUnits = {};
    // this.loadtype = 'FTL';
    this.showWeight = true;
    $('#f-option2').trigger('click');
    this.currentVehicleCapacity = '';
    $('#switch').removeClass('hover');
    this.isPaidByReceiverEnable = true;
    this.enableBidding = false;
    this.finalHandlersPrice = 0;
    this.metric_ton = 'Kg';
    $('#sendername, #sendernumber, #receivernumber, #sendernumber').attr(
      'disabled',
      false
    );
    if (this.initialCountryFlag) {
      $('#receivernumber, #sendernumber').intlTelInput(
        'setCountry',
        this.initialCountryFlag
      );
    }
    // console.log('model closed', this.initialCountryCode, this.initialCountryFlag);
    $('#sendername, #sendernumber, #receivernumber, #sendernumber').attr(
      'disabled',
      false
    );
    if (this.initialCountryFlag) {
      $('#receivernumber, #sendernumber').intlTelInput(
        'setCountry',
        this.initialCountryFlag
      );
    }
    $('#origin-input2').val('');
    $('.form-group.has-feedback').removeClass('has-success');
    $('.remove_details input,textarea').val('');
    $('.img-ul-clear').trigger('click');
    $('#est_journey').text('...');
    this.zone_one_title = ' ';
    this.zone_two_title = ' ';
    this.vehicletypeid = '';
    this.product_wid = '';
    this.product_lgt = '';
    this.product_ht = '';
    this.handlers = 0;
    this.fareEstimateDetails = [];
    // this.currency = '...';
    this.product_qty = '';
    $('#est_journey').text('');
    $('#choose_file_span').text('');
    this.approx = '.....';
    this.approx_dist_txt = '';
    this.duration = '';
    this.card_number = '';
    this.droplat = '';
    this.droplong = '';
    this.rec_name = '';
    this.rec_number = '';
    this.paidBy = 1;
    this.payment_type = 2;
    this.distance_text = '....';
    this.duration_txt = '....';
    this.show_ratecard = false;
    this.isCardEnable = false;
    this.isCashEnable = false;
    this.isWalletEnable = false;
    // clearInterval(this.vehicles_interval);
    $('#sender_input').attr('checked', false);
    $('#loader_place2').hide();
    $('.form-group').removeClass('has-error');
    $('.form-group').removeClass('has-success');
    $('label.error').remove();
    $('.multiple_img').hide();
    $('.ref_img1').show();
    $('.delete_photo_icn').hide();
    $('#upload1,#upload2,#upload3,#upload4,#upload5').attr(
      'src',
      './assets/img/image_upload.png'
    );
    this.file = [];
    $('select[name=goodstype]').val(
      $('select[name=goodstype] option:first').val()
    );
    $('select[name=handlers]').val(
      $('select[name=handlers] option:first').val()
    );
    $('select[name=vehicletype]').val(
      $('select[name=vehicletype] option:first').val()
    );
    $('select[name=handlers]').val(
      $('select[name=handlers] option:first').val()
    );
    $('select[name=payment_method]').val(
      $('select[name=payment_method] option:first').val()
    );
    $('#f-option2').trigger('click');
    $('#s-option4').trigger('click');
    $('#s-option1').trigger('click');
    $('#cbWalletBal').prop('checked', false);
    this.walletPay = 0;
    this.new_customer = false;
  }

  ngOnInit() {
    // model close function to clear form details
    $('#myModal').on('hidden.bs.modal', () => {
      this.vehicle_types = [];
      this.goods_type_list = [];
      // console.log('model hidden')
      // this.clearCards();
      this.customer_id = '';
      this.goods_type_list = [];
      this.vehicle_types = [];
      $('#form1')[0].reset();
      this.showWeight = true;
      $('#f-option1').prop('checked', true);
      $('#f-option2').prop('checked', false);
      this.allcards = [];
      this.card_number = '';
      this.default_card = [];
      this.defaultcard = '';
      this.cardPayment = false;
      this.loadtype = 'LTL';
      this.IsPriceFixed = false;
      this.currentVehicleCapacity = '';
      $('#switch').removeClass('hover');
      this.isPaidByReceiverEnable = true;
      this.enableBidding = false;
      this.finalHandlersPrice = 0;
      this.metric_ton = 'Kg';
      $('#sendername, #sendernumber, #receivernumber, #sendernumber').attr(
        'disabled',
        false
      );
      if (this.initialCountryFlag) {
        $('#receivernumber, #sendernumber').intlTelInput(
          'setCountry',
          this.initialCountryFlag
        );
      }
      console.log(
        'model closed',
        this.initialCountryCode,
        this.initialCountryFlag
      );
      $('#sendername, #sendernumber, #receivernumber, #sendernumber').attr(
        'disabled',
        false
      );
      if (this.initialCountryFlag) {
        $('#receivernumber, #sendernumber').intlTelInput(
          'setCountry',
          this.initialCountryFlag
        );
      }
      $('#origin-input2').val('');
      $('.form-group.has-feedback').removeClass('has-success');
      $('.remove_details input,textarea').val('');
      $('.img-ul-clear').trigger('click');
      $('#est_journey').text('...');
      this.zone_one_title = ' ';
      this.zone_two_title = ' ';
      this.vehicletypeid = '';
      this.product_wid = '';
      this.product_lgt = '';
      this.product_ht = '';
      this.handlers = 0;
      this.file = [];
      this.fareEstimateDetails = [];
      // this.currency = '...';
      this.product_qty = '';
      $('#est_journey').text('');
      $('#choose_file_span').text('');
      this.approx = '.....';
      this.approx_dist_txt = '';
      this.duration = '';
      this.card_number = '';
      this.droplat = '';
      this.droplong = '';
      this.rec_name = '';
      this.rec_number = '';
      this.paidBy = 1;
      this.payment_type = 2;
      this.distance_text = '....';
      this.duration_txt = '....';
      this.show_ratecard = false;
      this.isCardEnable = false;
      this.isCashEnable = false;
      this.isWalletEnable = false;
      // clearInterval(this.vehicles_interval);
      $('#sender_input').attr('checked', false);
      $('#loader_place2').hide();
      $('.form-group').removeClass('has-error');
      $('.form-group').removeClass('has-success');
      $('label.error').remove();
      $('.multiple_img').hide();
      $('.ref_img1').show();
      $('.delete_photo_icn').hide();
      $('#upload1,#upload2,#upload3,#upload4,#upload5').attr(
        'src',
        './assets/img/image_upload.png'
      );
      this.file = [];
      $('select[name=goodstype]').val(
        $('select[name=goodstype] option:first').val()
      );
      $('select[name=handlers]').val(
        $('select[name=handlers] option:first').val()
      );
      $('select[name=vehicletype]').val(
        $('select[name=vehicletype] option:first').val()
      );
      $('select[name=handlers]').val(
        $('select[name=handlers] option:first').val()
      );
      $('select[name=payment_method]').val(
        $('select[name=payment_method] option:first').val()
      );
      $('#f-option2').trigger('click');
      $('#s-option4').trigger('click');
      $('#s-option1').trigger('click');
      $('#cbWalletBal').prop('checked', false);
      this.walletPay = 0;
      this.showAllPayments = false;
      this.new_customer = false;
    });
    // $('#form1').disableAutoFill();
    // if(!sessionStorage.getItem('authtoken')) {
    if (!this._cookie.getItem('devtoken')) {
      this._router.navigate(['login']);
    } else {
      this.getCity();
      this.accountType = parseInt(this._cookie.getSettings('accountType'));
      if (this.accountType == 2) {
        // this.wallet();
        // this.getallcards();
      }
      this.card_wallet_validate();
      toastr.options = {
        // toast messages settings
        closeButton: true,
        debug: false,
        newestOnTop: false,
        progressBar: true,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        onclick: null,
        showDuration: '300',
        hideDuration: '1000',
        timeOut: '8000',
        extendedTimeOut: '1000',
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut'
      };
      // this.getVechicles();
      this.currentlat();
      // this.get_dates();
      this.telephone_input_validate();
      this.jquery_func_trigger();
      // this.profile_me();
      // $("#review_popup").modal('show');
      // this.pending_reviews();
      // this.getvehicles();
      let autocomplete;
      setTimeout(() => {
        this.directionsDisplay = new google.maps.DirectionsRenderer({
          // google path no default markers
          suppressMarkers: true
        });
        autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('pac-input2'),
          { types: ['geocode'] }
        );
      }, 3000);

      // $('#confirmmail_phone').modal({backdrop: 'static', keyboard: false});
      $('[data-toggle="tooltip"]').tooltip();
      this.current_time = new Date();
      this.current_time_var = moment().format('YYYY-MM-DD HH:mm:ss');

      // end of custom file input

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.

      $('.fullscreen_icn').on('click', event => {
        screenfull.toggle();
        $('.fullscreen_icn').toggleClass('glyphicon-fullscreen');
        $('.fullscreen_icn').toggleClass('glyphicon-resize-small');
      });

      $('.dropdown-toggle').click(function (e) {
        if ($(e.target).is('#notification_body,#notification_body *')) {
          return;
        } else {
          $('#notification_body').hide();
        }
      });
      $(document).click(function (e) {
        if ($(e.target).is('#notification_body,#notification_body *')) {
          return;
        } else {
          $('#notification_body').hide();
        }
      });

      this.validate_form = $('#form1').validate({
        rules: {
          username: {
            required: true
          },
          phonenumber: {
            required: true,
            uniqueCusNumber: true
          },
          email: {
            email: true,
            required: true
          },
          time: {
            required: true
          },
          weight: {
            minlength: 1,
            required: true
          },
          date: {
            required: this.bookNow ? false : true
          },
          receivername: {
            minlength: 3,
            required: true
          },
          receivernumber: {
            uniquePhonenumber: true,
            required: true
          },
          receiveremail: {
            email: true,
            required: true
          },
          password: {
            minlength: 5,
            required: true
          },
          payment: {
            required: true
          },
          pickuplocation: {
            findlocation: true,
            required: true
          },
          receiveraddress: {
            finddroplocation: true,
            required: true
          },
          goodstype: {
            required: true
          },
          vehicletype: {
            required: true
          },
          later_date: {
            minlength: 3,
            required: true
          },
          pickup_date: {
            required: true
          },
          sendername: {
            minlength: 3,
            required: true
          },
          sendernumber: {
            uniqueUserName: true,
            required: true
          },
          approx_amount: {
            required: true
          },
          handlers: {
            required: true
          }
        },
        highlight: function (element) {
          $(element)
            .closest('.form-group')
            .removeClass('has-success')
            .addClass('has-error');
        },
        unhighlight: function (element) {
          $(element)
            .closest('.form-group')
            .removeClass('has-error')
            .addClass('has-success');
        },
        submitHandler: form => {
          if (!this.bookNow) {
            if (this.validate_form.element('.flatpickr')) {
              if (this.validate_form.element('.flatpickr2')) {
                this.livebooking();
              }
            }
          } else {
            this.livebooking();
          }
        }
      });
      const telInput = $('#sendernumber'),
        telInput3 = $('#phonenumber'),
        errorMsg = $('#error-msg'),
        telInput2 = $('#receivernumber'),
        validMsg = $('#valid-msg');
      const reset = function () {
        console.log('reseting--->');
        telInput.removeClass('error');
        errorMsg.addClass('hide');
        validMsg.addClass('hide');
      };
      $.validator.addMethod(
        'findlocation',
        (value1: any, element) => {
          if (this.pickup_loc_bool && this.pickup_bool) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid location'
      );
      $.validator.addMethod(
        'finddroplocation',
        (value2, element) => {
          if (this.drop_loc_bool && this.drop_bool) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid location'
      );
      $.validator.addMethod(
        'uniqueUserName',
        function (value, element) {
          // telInput = element;
          // console.log('value--->', telInput, value, telInput.intlTelInput('isValidNumber'));
          if (telInput.intlTelInput('isValidNumber')) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid number'
      );

      $.validator.addMethod(
        'uniquePhonenumber',
        function (value, element) {
          // telInput = element;
          // console.log('value--->', telInput2, value, telInput2.intlTelInput('isValidNumber'));
          if (telInput2.intlTelInput('isValidNumber')) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid number'
      );

      $.validator.addMethod(
        'uniqueCusNumber',
        function (value, element) {
          // telInput = element;
          // console.log('value--->', telInput2, value, telInput2.intlTelInput('isValidNumber'));
          if (telInput3.intlTelInput('isValidNumber')) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid number'
      );
    }
    $('#sendernumber').on('countrychange', (e, countryData) => {
      // do something with countryData
      if ($('#sender_input').is(':checked')) {
        const countryData = $('#sendernumber').intlTelInput(
          'getSelectedCountryData'
        ).dialCode;
        // const countryData_id = $('#sendernumber').intlTelInput('getSelectedCountryData').iso2;
        // const classes = $('.receiver_number_parent2 .iti-flag').attr('class').split(' ');
        // $('.receiver_number_parent2 .selected-dial-code').text('+' + countryData);
        // $('.receiver_number_parent2 .iti-flag').removeClass(classes[1]);
        // $('.receiver_number_parent2 .iti-flag').addClass(countryData_id);
        const senderNumber = $('#sendernumber').val();
        // console.log('sender name and number', senderNumber, countryData);
        const Number = `+${countryData}${senderNumber}`;
        $('#receivernumber').intlTelInput('setNumber', Number);
        this.rec_name = this.senderName;
        setTimeout(() => {
          this.validate_form.element('#receivername,#receivernumber');
          this.validate_form.element('#receivernumber');
        }, 100);
      }
    });
  }

  errMsg: any;
  errmessage: any;
  addcards(cardid) {
    $('.card_error_msg').remove();
    $('.month_error_msg').remove();
    $('.loader_cardadd_parent').show();
    this._dispatcherService
      .addcards({
        email: this._cookie.getItem('email'),
        cardToken: cardid
      })
      .subscribe(
        (res: any) => {
          $('.select_card_button').trigger('click');
          // this.cardsDetails = res.data;
          // this.open_card();
          $('#card-expiration-month option:selected').val();
          $('#card-expiration-month').val(
            $('#card-expiration-month option:first').val()
          );
          $('#card-expiration-year').val(
            $('#card-expiration-year option:first').val()
          );
          $(
            '.ccv div,.card-expiration-date div,.credit-card-box .card-holder div,.credit-card-box .number'
          ).empty();
          $('#credit_card_popup input').val('');
          $('.loader_cardadd_parent').hide();
          $('.select_card_button').trigger('click');
          $('#new_cards_div').hide();
          this.card_number = '';
        },
        err => {
          $('.loader_cardadd_parent').hide();
          this.handleStatus(err.status, err.error);
        }
      );
  }

  new_customer = false;
  registered_customer = false;
  unregsitered_customer = false;
  name_list = [];
  phone_list = [];
  mail_list = [];
  countryCode: any;
  // customer search
  customer_search(e, field) {
    console.log(e.input.value, field);
    const typedValue = e.input.value;
    // if (field === 1) {
    //   this.cust_name = typedValue;
    //   this.cust_phone = '';
    //   this.cust_mail = '';
    //   this.customer_id = '';
    // } else if (field === 2) {
    //   this.cust_name = '';
    //   this.cust_phone = typedValue;
    //   this.cust_mail = '';
    //   this.customer_id = '';
    // } else {
    //   this.cust_name = '';
    //   this.cust_phone = '';
    //   this.cust_mail = typedValue;
    //   this.customer_id = '';
    // }

    if (typedValue) {
      this.new_customer = false;
      this.registered_customer = false;
      this.unregsitered_customer = false;
      if (typedValue) {
        this._dispatcherService
          .customersearching({
            email: typedValue
          })
          .subscribe(
            (res: any) => {
              if (res.data.length > 0) {
                this.new_customer = false;
              } else {
                this.new_customer = true;
                this.newCustAdd = true;
              }
              if (field == 1) {
                if (this.new_customer == true) {
                  this.selectDetails = false;
                } else {
                  this.selectDetails = true;
                  const cust = res.data;
                  for (let inst = 0; inst < cust.length; inst++) {
                    if (cust[inst].name == typedValue) {
                      if (cust[inst].registered == true) {
                        this.registered_customer = true;
                        this.unregsitered_customer = false;
                      } else {
                        this.registered_customer = false;
                        this.unregsitered_customer = true;
                      }
                      this.new_customer = false;
                      break;
                    }
                  }
                  if (
                    !this.registered_customer &&
                    !this.unregsitered_customer
                  ) {
                    this.new_customer = true;
                  }

                  this.mail_list = [];
                  this.phone_list = [];
                  this.name_list = res.data;
                }
              } else if (field == 2) {
                if (this.new_customer == true) {
                  this.selectDetails1 = false;
                  const countryData = $('#phonenumber').intlTelInput(
                    'getSelectedCountryData'
                  ).dialCode;
                  this.countryCode = '+' + countryData;
                  console.log(countryData);
                } else {
                  this.selectDetails1 = true;
                  const cust = res.data;
                  for (let inst = 0; inst < cust.length; inst++) {
                    if (cust[inst].phone == typedValue) {
                      if (cust[inst].registered == true) {
                        this.registered_customer = true;
                        this.unregsitered_customer = false;
                      } else {
                        this.registered_customer = false;
                        this.unregsitered_customer = true;
                      }
                      this.new_customer = false;
                      break;
                    }
                  }
                  if (
                    !this.registered_customer &&
                    !this.unregsitered_customer
                  ) {
                    this.new_customer = true;
                  }
                  this.mail_list = [];
                  this.name_list = [];
                  this.phone_list = res.data;
                }
              } else {
                if (this.new_customer == true) {
                  this.selectDetails2 = false;
                } else {
                  this.selectDetails2 = true;
                  const cust = res.data;
                  for (let inst = 0; inst < cust.length; inst++) {
                    if (cust[inst].email == typedValue) {
                      if (cust[inst].registered == true) {
                        this.registered_customer = true;
                        this.unregsitered_customer = false;
                      } else {
                        this.registered_customer = false;
                        this.unregsitered_customer = true;
                      }
                      this.new_customer = false;
                      break;
                    }
                  }
                  if (
                    !this.registered_customer &&
                    !this.unregsitered_customer
                  ) {
                    this.new_customer = true;
                  }
                  this.name_list = [];
                  this.phone_list = [];
                  this.mail_list = res.data;
                }
              }
            },
            err => {
              $('.loader_cardadd_parent').hide();
              this.handleStatus(err.status, err.error);
            }
          );
      } else {
        this.clearalldrops();
      }
    } else {
      this.selectDetails = false;
      this.selectDetails1 = false;
      this.selectDetails2 = false;
      this.name_list = [];
      this.phone_list = [];
      this.mail_list = [];
    }
  }

  clearalldrops() {
    this.mail_list = [];
    this.name_list = [];
    this.phone_list = [];
  }

  selectDetails = true;
  selectDetails1 = true;
  selectDetails2 = true;
  cust_name: any;
  cust_phone: any;
  cust_mail = '';
  customer_id: any;
  // autocomplete customer details
  autocomplete_text(customer) {
    // console.log('Autocomplete data', customer);
    this.customerPaymentDetails(customer);
    this.new_customer = false;
    if (customer.registered == true) {
      this.unregsitered_customer = false;
      this.registered_customer = true;
    } else {
      this.unregsitered_customer = true;
      this.registered_customer = false;
    }
    this.cust_name = customer.name.trim();
    this.cust_phone = customer.phone.trim();
    this.cust_mail = customer.email.trim();
    this.customer_id = customer.id;
    // $('#phonenumber').val(customer.phone);
    setTimeout(() => {
      $('#phonenumber').intlTelInput('setNumber', customer.phone);
    }, 100);

    $('#email').val(customer.email);
    this.sameAsCustomer(false);
    this.selectDetails = false;
    this.selectDetails1 = false;
    this.selectDetails2 = false;
    this.name_list = [];
    this.phone_list = [];
    this.mail_list = [];
    setTimeout(() => {
      $('#username,#phonenumber,#email').valid();
    }, 300);
  }

  customer_cards = [];
  default_card = [];
  self_payment = true;
  cardPayment = false;
  // get customer payment details
  customerPaymentDetails(customer) {
    this.card_number = '';
    this.customer_cards = [];
    this.default_card = [];
    this._dispatcherService
      .CustomerCardDetails({
        id: customer.id
      })
      .subscribe(
        (res: any) => {
          if (res.data.wallet !== undefined) {
            this.walletEnable = res.data.wallet.isEnabled;
            this.showing_balance = res.data.wallet.balance;
          }
          // adding card details fun by vivek
          if (res.data.cards.length > 0) {
            this.cardPayment = true;
            this.defaultcard = res.data.cards.filter(
              res => res.isDefault === true
            )[0];
            this.card_number = this.defaultcard.id;
            this.customer_cards = res.data.cards.map(res => res);
            this.allcards = res.data.cards.map(res => res);
            this.self_payment = true;
            console.log(
              this.default_card,
              this.card_number,
              this.customer_cards
            );
          } else {
            this.customer_cards = [];
            this.card_number = '';
            this.cardPayment = false;
          }
          // if (res.data.length > 0) {
          //   for (let inst = 0; inst < res.data.cards.length; inst++) {
          //     if (res.data.cards[inst].isDefault == true) {
          //       this.default_card = res.data.cards[inst];
          //       this.card_number = res.data.cards[inst].id;
          //     }
          //     this.customer_cards.push(res.data.cards[inst]);
          //     this.self_payment = true;
          //   }
          // } else {
          //   this.customer_cards = [];
          //   this.card_number = '';
          // }
        },
        err => {
          $('.loader_cardadd_parent').hide();
          this.handleStatus(err.status, err.error);
        }
      );
  }

  newCustAdd = true;
  // post new customer
  postNewCustomer() {
    const receiverCountryCode = $('#phonenumber').intlTelInput(
      'getSelectedCountryData'
    ).dialCode;
    let receiverNumber = $('#phonenumber').intlTelInput('getNumber', {
      nationalMode: true
    });
    receiverNumber = receiverNumber.replace(/\s/g, '');
    console.log(this.countryCode, this.cust_mail, this.cust_name);
    this._dispatcherService
      .postNewCustomer({
        name: this.cust_name,
        email: this.cust_mail,
        countryCode: `+${receiverCountryCode}`,
        phone: receiverNumber
      })
      .subscribe(
        (res: any) => {
          this.customer_id = res.data.customerId;
          this.newCustAdd = false;
        },
        err => {
          $('.loader_cardadd_parent').hide();
          this.handleStatus(err.status, err.error);
        }
      );
  }

  bookingsRange = false;
  city: any;
  all = false;
  cityid = this._cookie.getCityId('cityid');
  // get city list
  getCity() {
    $('.booking_loader_parent').show();
    this._dispatcherService.getCity({}).subscribe(
      (res: any) => {
        this.bookingsRange = res.data.isAllcityAccess;
        this.city = res.data.cityList;
        if (this.city.isAllcityAccess) {
          this.all = this.city.isAllcityAccess;
          this.cityid = '0';
          this._cookie.setCityId(this.cityid);
          this.getcityname(0);
        }
        $('.booking_loader_parent').hide();
      },
      err => {
        this.job_loader = false;
        this.handleStatus(err.status, err.error);
      }
    );
  }
  // get city name
  getcityname(event) {
    let selected_value = 0;
    event && event.target.value ? selected_value = event.target.value : selected_value = 0;
    console.log('selected_value', selected_value)
    if (selected_value == 0) {
      this._cookie.setCityId(selected_value);
      this._communicate.sendMessage(selected_value);
      this._communicate.cityChanged(0);
    } else {
      const index = this.city.findIndex(
        array => array.cityName == selected_value
      );
      if (index !== -1) {
        this.cityid = this.city[index].cityId;
        this._cookie.setCityId(this.cityid);
        this._communicate.sendMessage(this.city[index].cityId);
        this._communicate.cityChanged(this.city[index]);
        const currentCity = this.city[index];
        this.current_lat = currentCity.location.latitude;
        this.current_lng = currentCity.location.longitude;
        // console.log(this.city[index]);
      }
    }
    const data = {
      cityId: this.cityid,
      status: 99 // created status for city id change
    };
    setTimeout(() => {
      console.log("mwtt")
      this._missionService.announceMqtt(JSON.stringify(data));
    }, 500);
  }

  ngOnDestroy() {
    $('#myModal').modal('hide');
    // this._missionService.mqttDisconnect();
  }

  /**
   *
   *
   * @param string lang
   * @memberof DispatcherComponent
   * @description switch language
   */
  changeLanguage(lang) {
    this.translate.use(lang);
    this._cookie.setNewCookie('lang', lang, 10);
    // Remove Map Localization as it gives error and instance of map needs reinitilization
    // document
    //   .querySelectorAll('script[src^="https://maps.googleapis.com"]')
    //   .forEach(script => {
    //     script.remove();
    //   });
    // if (google) {
    //   delete google.maps;
    // }

    // fetch(`https://apidev.loademup.xyz/utility/currentKey`)
    //   .then(res => res.json())
    //   .then(res => {
    //     console.log(res);
    //     const key = res.data.currentKey;
    //     const newAPI = document.createElement('script');
    //     newAPI.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places,geometry&language=${lang}`;
    //     document.querySelector('head').appendChild(newAPI);
    //   });
  }

  getLanguages() {
    this._dispatcherService.getLanguages().subscribe(
      (res: any) => {
        console.log(res);
        this.allLanguages = res.data;
        this.translate.setDefaultLang('en');

        if (this._cookie.getItem('lang')) {
          this.defaultLanguage = this._cookie.getItem('lang');
          const index = this.allLanguages.find(
            language => language.code === this.defaultLanguage
          );
          if (index) {
            this.translate.use(this.defaultLanguage);
          } else {
            this.translate.use('en');
          }
        } else {
          this.translate.use('en');
        }

        console.log(this.defaultLanguage, this._cookie.getItem('lang'));
      },
      err => {
        console.log(err);
      }
    );
  }
  getcodAmount(event, val) {
    if (val == 0) {
      event && event.target ? this.codAmount = event.target.value : '';
    }

  }
}
